

class ShippingFeeProgress extends HTMLElement {
  constructor() {
    super();
    this.updateValue(`Only $${parseFloat(this.dataset.total).toFixed(2)}`, parseFloat(this.dataset.total))
  }
  updateText(text) {
    this.querySelector('.sf-text span').innerHTML = text;
  }
  updateValue(text, value) {
    this.querySelector('.p-c-progress+span').innerHTML = text
    let pPorgress = this.querySelector('.p-progress')
    let val = 100 * (value / 99);
    if (val < 10) {
      val = 4
      this.querySelector('.p-progress-container').classList.add('p-start-active')
    } else {
      this.querySelector('.p-progress-container').classList.remove('p-start-active')
    }
    let original_val = value;
    if (val > 90) {
      val = 96
      this.querySelector('.p-progress-container').classList.add('p-end-active')
    } else {
      this.querySelector('.p-progress-container').classList.remove('p-end-active')
    }
    pPorgress.style.width = `${100 - val}%`;
    let w = window.getComputedStyle(this.querySelector('.p-c-progress+span')).getPropertyValue('width')
    this.querySelector('.p-progress-container').classList.remove('p-start')
    this.querySelector('.p-progress-container').classList.remove('p-end')
    // if (val < 10) {
    //     this.querySelector('.p-progress-container').classList.add('p-start')
    //     this.querySelector('.p-c-progress+span').style.right = `auto`;
    //     this.querySelector('.p-c-progress+span').style.left = `-2.4%`;
    // } else if (val > 90) {
    //     this.querySelector('.p-progress-container').classList.add('p-end')
    //     this.querySelector('.p-c-progress+span').style.left = `auto`;
    //     this.querySelector('.p-c-progress+span').style.right = `1.6%`;
    // } else {
    //     this.querySelector('.p-c-progress+span').style.left = `calc(${val}% - ${parseFloat(w.replace('px', '')) / 2}px)`;
    //     this.querySelector('.p-c-progress+span').style.right = `auto`;
    // }
    this.querySelector('.p-c-progress+span').style.left = `calc(${100 - val}% + ${(val) / 2}% - ${parseFloat(w.replace('px', '')) / 2}px)`;
    this.querySelector('.p-c-progress+span').style.right = `auto`;
    if (original_val == 100) {
      pPorgress.style.width = '100%'
    }
  }
}
if (!customElements.get(`shipping-fee-progress`)) customElements.define('shipping-fee-progress', ShippingFeeProgress);
window.handleDevliverDate = () => {
  try {
    Array.from(document.querySelectorAll('.cart-area-items-data>div.ajaxcart__product'))
      .forEach(el => {
        let deliveryEl = el.querySelector('.ajaxcart__product-delivery-time-timestamp')
        if (deliveryEl) {
          var ts = deliveryEl.innerText.trim()
          var duration = ts - Math.round(Date.now() / 1000)
           let el_ = el.querySelector(".ajaxcart__product-delivery-time");
          if (duration > 0) {
            if (duration < 691200) {
              if (el_) el_.innerHTML = "In Stock (Ships in 1 week)";
              if (el.querySelector('.ajaxcart__product-meta._is_preorder')) {
                el.querySelector('.ajaxcart__product-meta._is_preorder').style.display = 'none'
              }
            } else if (duration < 1296000) {
              if (el_)el_.innerHTML = "In Stock (Ships in 2 weeks)";
              if (el.querySelector('.ajaxcart__product-meta._is_preorder')) {
                el.querySelector('.ajaxcart__product-meta._is_preorder').style.display = 'none'
              }
            }
          } else {
            if (el_) el_.innerHTML = "In Stock";
            if (el.querySelector('.ajaxcart__product-meta._is_preorder')) {
              el.querySelector('.ajaxcart__product-meta._is_preorder').style.display = 'none'
            }
          }
        }
      })
  } catch (error) {
    console.log(error)
  }
}
/**
* @param {} amount 
*/
const appendSaving = () => {
  let _class = 'compaign_saving'
  let savEle = document.querySelector(`.${_class}`);
  if (!savEle) {
    savEle = document.createElement('p')
    savEle.classList = _class

    let submitEle = document.querySelector('.cart-area-footer .docapp-est-placeholder')
    if (submitEle) {
      submitEle.parentNode.insertBefore(savEle, submitEle.nextSibling)
      savEle.style.color = '#9A4A27'
      savEle.style.fontWeight = '500'
      savEle.style.fontSize = '14px'
      savEle.style.textAlign = 'right'
      savEle.style.margin = '0px 0px 0px'
    }
  }
  // let discountSaving = (document.querySelector('p.ajaxcart__price.cart__discount')?.getAttribute?.('data-amount') ?? '0').replace('$', '')
  // let textcontent = document.querySelector('p.ajaxcart__price.cart__discount')?.textContent ?? ''
  //if (textcontent.indexOf('Flash Sale') > -1) { discountSaving = '0' }
  //savEle.innerHTML = `Saving $${(amount + parseFloat(discountSaving)).toFixed(2)}`
  // savEle.innerHTML = `${promotionTitle?`${promotionTitle}: `:''}Saving $${amount.toFixed(2)}`

  // handle original price of order
  // try {
  //     const couponSaving = document.querySelector('.discount-much .total-saving').textContent.replace('$', '').replace(',', '');
  //     let originTotal = amount + parseFloat(document.querySelector('.ajaxcart__price_total').textContent.replace('$', '').replace(',', ''))
  //         + parseFloat((couponSaving == '' ? '0' : couponSaving))
  //     let saveTotal = parseFloat(originTotal.toFixed(2)).toLocaleString();
  //     if (saveTotal.indexOf('.') == -1) {
  //         saveTotal = saveTotal + '.00'
  //     } else {
  //         saveTotal = saveTotal.split('.').slice(-1)[0].length === 1 ? saveTotal + '0' : saveTotal
  //     }
  //     document.querySelector('.total-original-price').innerHTML = `$${saveTotal}`;

  // } catch (error) {
  //     console.log(error)
  // }

}
/***
*  ## Cart Action -  update original price for line item
*/
const appendOriginalPrice = (price, ele, quantity) => {
  let _class = 'cart__price--strikethrough'
  let originalEle = ele.parentElement.parentElement.querySelector(`.${_class}`)

  if (!originalEle) {
    originalEle = document.createElement('small');
    originalEle.classList = _class
    let priceEle = ele?.parentElement?.parentElement?.querySelector?.(`.ajaxcart__price`)
    if (priceEle) {
      priceEle.parentElement.insertBefore(originalEle, priceEle)
      priceEle.setAttribute('data-compare-at-price', (price / quantity).toFixed(2))
    }
  } else {
    originalEle.parentElement.querySelector('.ajaxcart__price').setAttribute('data-compare-at-price', (price / quantity).toFixed(2))
  }
  originalEle.innerHTML = `$${price.toFixed(2)}`
  const currentPrice = originalEle.parentElement.querySelector('.ajaxcart__price').getAttribute('data-price')
  if (price / quantity > parseFloat(currentPrice)) {
    originalEle.classList.remove('hide')
  }
}
/**
* ## 为Manually Update Product Price活动显示节省金额
* @param {*} cart 
* @returns 
*/
window.campaignSavingInfoByUpdateProductPrice = async function (cart) {
  // == ONLY WORK FOR setting promotion sales by update product prices =================================================================
  if (!document.querySelector('.discount-json')) return;
  //alert('--000ß')
  let discountRes = JSON.parse(document.querySelector('.discount-json')?.textContent.trim() ?? '{}')

  let discounts = []
  const variantCompareMap = window.variantCompareMap || {} // {[variantid]:[compareAtPrice]}
  try {
    var urls = []

    cart.items.forEach(item => {
      if (item.discounts?.length) {

        discounts.push(item.discounts)
      }
      /**
       * en-us: (discountRes[item.variant_id] && !marketKey)
       * en-ca: !!marketKey
       */
      // only for bogo+update price in us and update price + bogo  LINE 
      // if ((discountRes[item.variant_id] && !marketKey) || !!marketKey) {
      if (discountRes[item.variant_id]) {
        let itemEle = document.querySelector(`.cart-area-items [href*="?variant=${item.variant_id}"], .cart-area-items [href*="&variant=${item.variant_id}"]`);

        let priceEle = itemEle?.parentElement?.parentElement?.querySelector?.(`.ajaxcart__price`);
        if (priceEle) {
          const comparePrice = parseFloat(priceEle.dataset.compareAtPrice?.replace?.(',', '').replace?.('$', '').trim?.() ?? '0') * 100
          const price = parseFloat(priceEle.dataset.price?.replace?.('$', '').replace?.(',', '').trim?.() ?? '0') * 100
          if (!comparePrice || (price > comparePrice)) {
            urls.push(itemEle.getAttribute('href'))
          } else {
            variantCompareMap[item.variant_id] = comparePrice
          }
        }
      }
    })

    discounts = Object.values(discounts.flat(1).reduce((res, item) => {

      if (!res[item.title]) {
        res[item.title] = {
          amount: 0,
          title: item.title,
        };
      }
      res[item.title].amount += item.amount;
      return res;
    }, {}))
    appendSaving(discounts)

    urls = urls.filter(url => {
      let vid = url.split('?')[1]
      return !variantCompareMap[vid]
    })
    if (urls.length) {
      let res = await Promise.all(urls.map(item => {
        return new Promise(async (resolve, reject) => {
          const res = await fetch(item.split('?')[0] + '.js')
          resolve(res?.json?.());
        })
      }))
      res.forEach((item, index) => {
        let para = new URLSearchParams('?' + urls[index].split('?')[1])
        let vid = para.get('variant');
        let v = item.variants.find(item => `${item.id}` == para.get('variant'))
        variantCompareMap[vid] = v.compare_at_price
      })
    }

  } catch (error) {
    console.log(error)
  }

  cart.items.forEach((item, itemIndex) => {


    /**
     * en-us: (discountRes[item.variant_id] && !marketKey)
     * en-ca: !!marketKey
     */
    // only for bogo+update price in us and update price + bogo  LINE 
    let itemEle = document.querySelector(`.cart-area-items .cart-area-items-data>.ajaxcart__product:nth-child(${itemIndex + 2}) [href*="?variant=${item.variant_id}"],.cart-area-items .cart-area-items-data>.ajaxcart__product:nth-child(${itemIndex + 2}) [href*="&variant=${item.variant_id}"]`);
    if (itemEle) {
      if ((discountRes[item.variant_id])) {

        let priceEle = itemEle?.parentElement?.parentElement?.querySelector?.(`.ajaxcart__price`);

        const comparePrice = variantCompareMap[item.variant_id]??0;
        const price = parseFloat(priceEle.dataset?.price?.replace?.('$', '').trim?.() ?? '0') * 100
        //if (comparePrice && comparePrice > 0 && price < comparePrice && item.discounts.length == 0) {
        if (comparePrice && comparePrice > 0 && price < comparePrice) {
          let itemSaving = ((comparePrice - price) / 100) * item.quantity;

          const t = document.createElement('div');
          let promotionTitle = document.querySelector('#CartDrawer').getAttribute('data-title');

          let itemPromotion = promotionTitle
          // bundle sale badge in cart line item
          if ((window.customizeBundles)?.includes?.(itemEle.getAttribute('href').split('?')[0].split('/').slice(-1)[0])) {
            itemPromotion = 'Bundle Sale'
          }
          t.innerHTML = `${itemPromotion} Saving: $${itemSaving.toFixed(2)}`
          t.style = "font-size: 12px;color: var(--primaryColor);font-weight: 400;"
          t.classList = 'extra-saving'
          if (!itemEle?.parentElement.parentElement.querySelector('.extra-saving')) {
            let pEl = itemEle?.parentElement?.nextElementSibling;
            if (pEl.querySelector('.ajaxcart__discount')) {
              let preSibling = pEl.querySelector('.ajaxcart__discount').closest('.display-table')
              if (item.discounts.length == 0 || item.discounts[0].title == 'Saving') preSibling.parentElement.insertBefore(t, preSibling)
            } else {
              if (item.discounts.length == 0) pEl?.appendChild?.(t)
            }
          }
          appendOriginalPrice(((comparePrice) / 100) * item.quantity, itemEle, item.quantity)
        }

      } else {
        let lineEl = itemEle.closest('.ajaxcart__product')
        let priceEl = lineEl.querySelector('.ajaxcart__price')
        let original_price = item.properties?.__original_price;
        let original_price_cart = (item.original_price / 100).toFixed(2)
        if (original_price && original_price != original_price_cart)
          original_price_cart = original_price;
        let price_ = (item.price / 100).toFixed(2);
        if (original_price_cart)
          priceEl.setAttribute("data-compare-at-price", original_price_cart);
        priceEl.setAttribute("data-price", price_);
        if (original_price&&original_price != price_)
          appendOriginalPrice(
            parseFloat(original_price) * item.quantity,
            itemEle,
            item.quantity,
          );
      }
    }
  })
  window.fixCartExtraSavingAfterDiscount(discounts, cart.items, cart)
}

/**
* ## 展示每满`LEVEL_AMOUNT`金额，赠送`GIFT_AMOUNT`金额 Saving 信息
* - WHEN senting 30 gift cart for every spent 150 
* @param {*} cart 
*/
window.campaignFreeGiftCardInfo = (cart) => {
  let _total = cart.total_price
  let LEVEL_AMOUNT = 150
  let GIFT_AMOUNT = 30
  let SALE_NAME = `Free Gift Box Saving`
  // exclude gift cards
  let giftCards = cart.items.filter(item => item.url.indexOf(`/vego-garden-gift-card`) > -1)
  if (giftCards.length) {
    giftCards.forEach(card => {
      _total -= card.line_price
    })
  }

  let total = (_total / 100)
  let numFreeGiftCard = Math.floor(total / LEVEL_AMOUNT)
  let freeGiftCardProInfo = document.querySelector('.free-gift-card');
  if (freeGiftCardProInfo) freeGiftCardProInfo.innerHTML = numFreeGiftCard > 0 ? `${SALE_NAME} Saving <b>$${(numFreeGiftCard * GIFT_AMOUNT).toFixed(2)}</b>` : ''
}

/***
* update cart saving amount after adding/removing discount code
*/
window.fixCartExtraSavingAfterDiscount = async (discounts, items = null, cart) => {
  if (!items) {
    let res = await theme.cart.getCart()
    items = res.items;
  }
  items.forEach((item, index) => {
    let lineEl = document.querySelector(`.cart-area-items-data >div:nth-child(${index + 2})`)

    if (item.discounts?.length && item.properties.__original_price) {
      let original_price = parseFloat(
        item.properties.__original_price.replace(",", ""),
      );
      let amount = (original_price - item.price / 100) * item.quantity;
      let promotion_title = document.querySelector('#CartDrawer').getAttribute('data-title')
      if ((window.customizeBundles)?.includes?.(item.url.split('?')[0].split('/').slice(-1)[0])) {
        promotion_title = 'Bundle Sale'
      }
      //fix: subtotal between compare at price and price
      if (!lineEl.querySelector(".extra-saving") && amount!=0) {
        let line_extra_saving = `<div class="extra-saving" style="font-size: 12px; color: var(--primaryColor); font-weight: 400;">${promotion_title} Saving: $${amount.toFixed(2)}</div>`;
        let el = document.createElement("div");
        let p_el = lineEl.querySelector(
          ".grid.grid--full.display-table",
        ).parentElement;
        el.innerHTML = line_extra_saving;
        if (p_el.textContent.indexOf(promotion_title) == -1)
          p_el.appendChild(el);
      }
      if (cart?.cart_level_discount_applications?.length && item.discounts.length) {
        let line_extra_saving = `<div class="extra-saving" style="font-size: 12px; color: var(--primaryColor); font-weight: 400;">${item.discounts[0].title} Saving: $${(item.discounts[0].amount / 100).toFixed(2)}</div>`
        let el = document.createElement('div')
        el.innerHTML = line_extra_saving
        let p_el = lineEl.querySelector('.grid.grid--full.display-table').parentElement
        if (p_el.textContent.indexOf(item.discounts[0].title) == -1) p_el.appendChild(el)
      }
      //fix: reset compare at price
      let compareAtPriceEl = lineEl.querySelector('.cart__price--strikethrough')
      if (compareAtPriceEl) compareAtPriceEl.innerHTML = `$${((original_price) * item.quantity).toFixed(2)}`
    } else if (item.discounts?.length && !item.properties.__original_price) {
      if (
        cart?.cart_level_discount_applications?.length &&
        item.discounts.length
      ) {
        let line_extra_saving = `<div class="extra-saving" style="font-size: 12px; color: var(--primaryColor); font-weight: 400;">${item.discounts[0].title} Saving: $${(item.discounts[0].amount / 100).toFixed(2)}</div>`;
        let el = document.createElement("div");
        el.innerHTML = line_extra_saving;
        let p_el = lineEl.querySelector(
          ".grid.grid--full.display-table",
        ).parentElement;
        if (p_el.textContent.indexOf(item.discounts[0].title) == -1)
          p_el.appendChild(el);
      }
    }

  })

  window.reCalulateSaving(discounts)


}

/****
*  ## recalculate cart saving and update cart save ui
*/
window.reCalulateSaving = (discounts = []) => {

  Array.from(document.querySelectorAll('.ajaxcart__product.ajaxcart-combo-box .cart__discount')).forEach(item => {
    if (!discounts.length) item.style.display = 'none'
    else item.style.display = 'block'
  })

  let items = Array.from(document.querySelectorAll('.ajaxcart__product.ajaxcart-combo-box'))
  let saving_total = items.reduce((res, item) => {
    let priceEl = item.querySelector('[data-compare-at-price]')
    let quantity = item.querySelector('[name="updates"]').value
    let compare_at_price = priceEl.getAttribute('data-compare-at-price').replace(',', '')
    if (compare_at_price=='undefined'||!compare_at_price || compare_at_price == `0` || parseFloat(compare_at_price) < parseFloat(priceEl.getAttribute('data-price'))) {
      priceEl.setAttribute('data-compare-at-price', priceEl.getAttribute('data-price'))
      compare_at_price = priceEl.getAttribute('data-price')
    }
    res += (parseFloat(compare_at_price) - parseFloat(priceEl.getAttribute('data-price'))) * quantity
    return res;
  }, 0)
  let discount_saving = discounts.reduce((res, item) => {
    res += (item.amount / 100)
    return res;
  }, 0)
  if (document.querySelector('.compaign_saving')) {
    let total = saving_total + discount_saving
    if (total == 0 || isNaN(total)) {
      document.querySelector('.compaign_saving').style.display = 'none'
    } else {
      document.querySelector('.compaign_saving').style.display = 'block'
      document.querySelector('.compaign_saving').innerHTML = `Saving $${(saving_total + discount_saving).toFixed(2)}`
    }

  }
}

class ShippingFeeV0 extends BaseV2 {
  constructor() {
    super();
  }
  renderShippingFee(totalSoilShippingFee) {
    if (!totalSoilShippingFee) totalSoilShippingFee = this.shippingFee;
    let txt =
      totalSoilShippingFee == 0
        ? "Free"
        : theme.Currency.formatMoney(
            totalSoilShippingFee,
            theme.settings.moneyFormat,
          );
    this.style.display = "block";
    let shippingFeeEl = this.querySelector(".shipping-fee-amount");
    if (shippingFeeEl) shippingFeeEl.innerHTML = txt;
  }
  green_house_handle = [
    // "vego-junior-victorian-greenhouse-8-0-x-13-with-elevated-garden-bed-slim-series-1-5-x-5-5-wheels-included",
    // "vego-junior-victorian-greenhouse-8-0-x-10-5-with-elevated-garden-bed-slim-series-1-5-x-3-5-wheels-included",
    // "vego-grand-victoria-greenhouse-12-5ft-wide-foldable-shelf-with-seed-starting-bundle-10x-20",
    // "vego-grand-victoria-greenhouse-12-5ft-wide-17-tall-modern-27-x-53-metal-raised-garden-bed-2-set",
    // "vego-grand-victoria-greenhouse-12-5ft-wide-17-tall-modern-27-x-83-metal-raised-garden-bed-2-set",
    // "vego-grand-victorian-greenhouse-12-5ft-wide-4-tier-grow-light-garden-pro-with-bistro-set",
    // "vego-grand-pacific-greenhouse-12-5ft-wide-4-tier-grow-light-garden-pro-with-bistro-set",
    // "vego-diamond-pavilion-greenhouse-bistro-set",
    // "vego-grand-pacific-greenhouse-12-5ft-wide-with-6-pot-holder-3-pack",
    // "vego-pacific-greenhouse-10-5ft-wide-with-6-pot-holder-3-pack",
    // "vego-pacific-greenhouse-8-5ft-wide-with-6-pot-holder-3-pack",
    // `vego-garden-pacific-greenhouse`,
    // `vego-garden-junior-victoria-greenhouse-8-0-ft`,
    // `vego-garden-pacific-greenhouse-12-5-ft`,
    // `vego-garden-pacific-greenhouse-10-5-ft`,
    // `vego-garden-junior-victorian-greenhouse-6-5-ft`,
    // `vego-garden-victorian-greenhouse-12-5-ft`,
    // `vego-garden-victorian-greenhouse-10-5-ft`,
    // `vego-garden-victorian-greenhouse-85-ft`,
    // `vego-diamond-pavilion-greenhouse`,
    // "lean-to-greenhouse-6-5-x-8-5",
    // "lean-to-greenhouse-8-5-x-12-5",
    // "lean-to-greenhouse-4-5-x-8-5",
    // "greenhouse-glow-up",
    // "vego-oasis-greenhouse-12-9-x-12-9",
    // "vego-oasis-greenhouse-10-5-x-10-5",
    // "vego-grand-oasis-greenhouse",
    // "vego-oasis-greenhouse",
    // "grand-oasis-greenhouse-15-5-x-10-5",
    // "vego-grand-oasis-greenhouse-18-0-x-12-9",
  ];
  green_house_shipping_fee_config = null;
  parseGreenhouseShippingFee() {
    if (this.green_house_shipping_fee_config)
      return this.green_house_shipping_fee_config;
    let green_house_shipping_fee_config = document.querySelector(
      "#green_house_shipping_fee_config",
    )?.value;
    if (green_house_shipping_fee_config) {
      let config = JSON.parse(green_house_shipping_fee_config).reduce(
        (res, item) => {
          if (!item.variant_item && item.product) {
            item.product.forEach((p_id) => {
              res["p_" + p_id.split("/").slice(-1)[0]] = parseFloat(
                item.option_shipping_fee,
              );
            });
          } else if (item.variant_item) {
            res[item.variant_item.split("/").slice(-1)[0]] = parseFloat(
              item.option_shipping_fee,
            );
          }
          return res;
        },
        {},
      );
      this.green_house_shipping_fee_config = config;
      return this.green_house_shipping_fee_config;
    } else {
      return {};
    }
  }
  parseGreenhouseShippingFeeByVariantId(variantId, productId) {
    let cfg = this.parseGreenhouseShippingFee();
    return cfg[variantId] ?? cfg["p_" + productId] ?? 299.95;
  }
  /**
   * Shipping Information Array to Display
   */
  shippingInfo = [];
  /**
   * calc total shipping fee
   * @param {*} cartItems
   * @returns
   */
  shippingFeeFn(cartItems) {
    //let el = document.querySelector('.shipping-config')
    let green_house = this.green_house_handle;
    let green_house_fee = 0;
    let green_house_amount = 0;
    let fc_handles = [
      `foodcube-the-next-generation-of-raised-garden-self-watering-elevated`,
      `foodcube-slim`,
      `foodcube-wall-trellis`,
      `foodcube`,
      "home-farm-kit",
      `foodcube-slim-the-next-generation-of-raised-garden-self-watering-elevated`,
    ];
    let fc_trellis_fee = 0;
    let exist_fc = cartItems.find((item) => fc_handles.includes(item.handle));
    let fc_total_amount = 0;
    let fc_total_amount_fee = 0;
    cartItems.forEach((item) => {
      if (fc_handles.includes(item.handle)) {
        /**
         * Special handle shipping fee for Home Farm Kit
         */
        if (item.handle == "home-farm-kit") {
          fc_total_amount += item.quantity * 28465 * 4;
        } else {
          fc_total_amount += item.quantity * item.price;
        }
      }
    });
    if (fc_total_amount < 249900 && exist_fc) fc_total_amount_fee = 249;
    else fc_total_amount_fee = 0;

    const upgrade_delivery = 150;

    cartItems.map((item) => {
      if (green_house.includes(item.handle)) {
        let perFee = this.parseGreenhouseShippingFeeByVariantId(
          item.variant_id,
          item.product_id,
        );
        if (item.properties._is_upgrade_delivery == "true") {
          perFee = perFee + upgrade_delivery;
        }
        green_house_amount += item.quantity * item.price;
        green_house_fee += perFee * item.quantity;
      }
    });
    return {
      fc_total_amount_fee,
      fc_total_amount,
      fee: (fc_total_amount_fee + fc_trellis_fee + green_house_fee) * 100,
      fc_green_house_amount: fc_total_amount + green_house_amount,
    };
  }

  shippingInfoFn({
    fc_total_amount,
    original_total_price,
    original_total_seedling_price,
    fc_total_amount_fee,
  }) {
    this.shippingInfo = "";
    let current_min_value = 0;
    if (fc_total_amount > 0) {
      // this.shippingInfo.push("You've unlocked the free shipping rule for the foodcube series.")
      if (fc_total_amount_fee > 0) {
        current_min_value = 249900 - fc_total_amount;
        this.shippingInfo = `Add $${
          (249900 - fc_total_amount) / 100
        } to get <span>free shipping</span> on the foodcube!`;
      }
    }
    if (original_total_seedling_price) {
      if (original_total_seedling_price < 1999) {
        if (
          current_min_value == 0 ||
          current_min_value > 1999 - original_total_seedling_price
        ) {
          current_min_value = 1999 - original_total_seedling_price;
          this.shippingInfo = `Add $${
            (1999 - original_total_seedling_price) / 100
          } to get <span>free shipping</span> on the seeds!`;
        }
      }
    }
    if (original_total_price) {
      if (original_total_price < 9900) {
        if (
          current_min_value == 0 ||
          current_min_value > 9900 - original_total_price
        ) {
          current_min_value = 9900 - original_total_price;
          this.shippingInfo = `Add $${
            (9900 - original_total_price) / 100
          } to get <span>free shipping</span> for the garden bed & add on!`;
        }
      }
    }

    let sibEl = document.querySelector(".shipping-information-box");
    if (!sibEl) return;
    if (
      this.shippingInfo &&
      (original_total_seedling_price != 0 ||
        original_total_price != 0 ||
        fc_total_amount_fee != 0)
    ) {
      sibEl.style.display = "flex";
      sibEl.innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="18" height="18" fill="#F8ECCB"/>
<path d="M3.44901 13.8341C3.44901 14.2825 3.62712 14.7125 3.94416 15.0296C4.26121 15.3466 4.69122 15.5247 5.13958 15.5247C5.58795 15.5247 6.01796 15.3466 6.335 15.0296C6.65205 14.7125 6.83016 14.2825 6.83016 13.8341C6.83016 13.3858 6.65205 12.9558 6.335 12.6387C6.01796 12.3217 5.58795 12.1436 5.13958 12.1436C4.69122 12.1436 4.26121 12.3217 3.94416 12.6387C3.62712 12.9558 3.44901 13.3858 3.44901 13.8341Z" fill="#3A5B39"/>
<path d="M15.506 6.47059L12.1288 4.58399V3.93209C12.1288 2.86944 11.2594 2 10.1967 2H3.93209C2.86944 2 2 2.86944 2 3.93209V11.6605C2 12.2075 2.23043 12.7033 2.59899 13.0557C2.93174 11.9683 3.94328 11.1774 5.13965 11.1774C6.52542 11.1774 7.66318 12.2385 7.78522 13.5925H10.2078C10.3299 12.2385 11.4676 11.1774 12.8534 11.1774C14.0497 11.1774 15.0613 11.9683 15.394 13.0557C15.7626 12.7033 15.993 12.2075 15.993 11.6605V7.43257C16.0388 7.0545 15.8577 6.66703 15.506 6.47059ZM14.544 8.76232C14.544 9.02798 14.3266 9.24534 14.0609 9.24534H12.1288C11.8632 9.24534 11.6458 9.02798 11.6458 8.76232V6.83023C11.6458 6.56456 11.8632 6.3472 12.1288 6.3472C12.3945 6.3472 12.6119 6.56456 12.6119 6.83023V8.27929H14.0609C14.3266 8.27929 14.544 8.49665 14.544 8.76232Z" fill="#3A5B39"/>
<path d="M11.163 13.8341C11.163 14.2825 11.3411 14.7125 11.6582 15.0296C11.9752 15.3466 12.4052 15.5247 12.8536 15.5247C13.302 15.5247 13.732 15.3466 14.049 15.0296C14.3661 14.7125 14.5442 14.2825 14.5442 13.8341C14.5442 13.3858 14.3661 12.9558 14.049 12.6387C13.732 12.3217 13.302 12.1436 12.8536 12.1436C12.4052 12.1436 11.9752 12.3217 11.6582 12.6387C11.3411 12.9558 11.163 13.3858 11.163 13.8341Z" fill="#3A5B39"/>
</svg><p>${this.shippingInfo}</p>`;
    } else {
      sibEl.style.display = "none";
    }
  }
  addExtraInforForBundle(items) {
    let bundles = {
      bundle: {
        bundle1: {
          price: 120,
          quantity: 2,
        },
      },
    };
    let splite_items = [];
    items = items.filter((item) => {
      let bundle_item = bundles[item.handle];
      if (!bundle_item) return true;
      Object.keys(splite_items).forEach((bundle_item_proudct_handle) => {
        splite_items.push({
          handle: bundle_item_proudct_handle,
          final_line_price: product.final_line_price,
          quantity: product.quantity,
          price: product.price,
        });
      });
      return false;
    });
    items = items.concat(splite_items);
  }
  calcShippingFee(cart, render = false) {
    if (!cart) return 0;
    let shippingFee = 0;
    let totalFeeFreeGift = 0;
    let totalFeeIncludeSoildRoute = 0,
      totalNumIncludeSoildRoute = 0;
    let shippingFee20Arr = (
      document
        .querySelector("[data-shipping-fee20]")
        .getAttribute("data-shipping-fee20") ?? ""
    ).split(","); // shipping fee $20 config
    let shippingFee995Arr =
      `slow-release-organic-fertilizer,worm-castings,vego-garden-planter-mix,vego-indoor-potting-mix,vego-garden-seed-starter-mix`.split(
        ",",
      ); // shipping fee $20 config
    let plant_total = 0;
    let original_total_seedling_price = 0;
    // const teamGrowSeedlingHandle = [
    //   '42-day-tomato',
    //   "marketer-cucumber",
    //   'yellow-scallop-squash',
    //   'giant-nobel-spinach'
    // ];

    this.addExtraInforForBundle(cart.items);

    for (var product of cart.items) {
      if (product.product_type == "Plant") {
        plant_total += product.final_line_price;
      }

      if (theme.isCA()) {
        let num = 1;
        if (window.bundle_map_num_v2[product.variant_id]) {
          // app discount applied
          num = window.bundle_map_num_v2[product.variant_id];
        } else if (window.bundle_map_num?.[product.handle]) {
          // cart render
          num = window.bundle_map_num[product.handle];
        }
        shippingFee += 4500 * product.quantity * num;
        let optionWithIntermediateFloor = product.options_with_values.find(
          (item) => item.name == "With Intermediate Floor",
        );
        if (optionWithIntermediateFloor) {
          //shippingFee += 4500 * product.quantity * num
        }
        //let elevatedGardenBedsWithWheels = product.handle == 'elevated-garden-bed-v-series-2-x-8-with-wheels'
        if (
          [
            `elevated-garden-bed-v-series-2-x-6-with-wheels`,
            "elevated-garden-bed-v-series-2-x-4-with-wheels",
            // "elevated-garden-bed-v-series-2-x-8-with-wheels",
            "elevated-garden-bed-2-x-8",
          ].includes(product.handle)
        ) {
          shippingFee += 4500 * product.quantity * num;
        }
      } else if (!theme.isAu()) {
        if (shippingFee995Arr.includes(product.handle)) {
          if (`${product.variant_id}` == "40850585419811") {
            shippingFee += 1795 * product.quantity;
          } else {
            shippingFee += 995 * product.quantity;
          }
        } else if (shippingFee20Arr.includes(product.handle)) {
          shippingFee += 1795 * product.quantity;
        }
      }
      if (
        shippingFee995Arr.includes(product.handle) ||
        shippingFee20Arr.includes(product.handle)
      ) {
        totalFeeIncludeSoildRoute += product.final_line_price;
        totalNumIncludeSoildRoute += product.quantity;
        //  products_20_995_arr_amount += product.final_line_price
      } else if (
        product.handle == "free-herb-planter-box-with-trellis-gift" ||
        product.handle == "salad-serving-bowl-gift-box" ||
        product.handle == "free-watering-kits-gift" ||
        product.handle == "mini-planter-gift-box" ||
        product.handle == "free-mini-planter-gift-box" ||
        product.handle == "free-gift" ||
        product.handle == "routeins" ||
        product.handle == "21-day-seed-starting-challenge" ||
        product.gift_card
      ) {
        totalFeeFreeGift += product.final_line_price;
      }
    }
    const self = this;
    if (!theme.isCA() && !theme.isAu()) {
      let { fc_total_amount_fee, fc_total_amount, fee, fc_green_house_amount } =
        this.shippingFeeFn(cart.items);
      shippingFee += fee;
      //=== stuff fee ===
      let original_total_price = cart.items.reduce((res, item) => {
        res += item.final_line_price;
        return res;
      }, 0);

      original_total_seedling_price = cart.items.reduce((total, item) => {
        if (
          item.vendor == "MIgardener" ||
          self.vego_seeds.includes(item.handle)
        ) {
          if (
            item.handle == "free-deluxe-seed-starting-pack" ||
            item.handle == "free-seed-starting-pack-gift-box" ||
            item.handle == "free-winter-fall-seeds-kit-gift"
          ) {
            total += 6000 * item.quantity;
          } else {
            total += item.final_line_price;
          }
        }
        return total;
      }, 0);
      let original_total_subscription_price = cart.items.reduce(
        (total, item) => {
          if (
            item.handle == "carbon-filter-refill-kit-vegotab-bundle" ||
            item.handle == "vegotabs" ||
            item.handle == "carbon-refill-kit"
          ) {
            total += item.final_line_price;
          }
          return total;
        },
        0,
      );

      if (
        original_total_seedling_price != 0 &&
        original_total_seedling_price < 1999
      ) {
        shippingFee += 395;
      }

      original_total_price =
        original_total_price -
        plant_total -
        //original_total_subscription_price -
        //original_total_seedling_price -
        totalFeeFreeGift; //- fc_green_house_amount - original_total_seedling_price //- plant_total  ///- totalFeeIncludeSoildRoute
      if (
        original_total_price != 0 &&
        original_total_price < 9900 &&
        !theme.isCA() &&
        !theme.isAu() &&
        original_total_price !=
          original_total_subscription_price +
            totalFeeIncludeSoildRoute +
            original_total_seedling_price
      ) {
        shippingFee += 1395;
      }
      this.shippingInfoFn({
        fc_total_amount_fee,
        fc_total_amount,
        original_total_price,
        original_total_seedling_price,
      });
    }
    if (render) {
      this.renderShippingFee(shippingFee);
    } else {
      this.shippingFee = shippingFee;
    }
    return shippingFee;
  }
  shippingFee = 0;
  vego_seeds = [];
  connectedCallback() {
    //console.log(this.querySelector("textarea").textContent);
    let vego_seeds = JSON.parse(this.querySelector("textarea").textContent);
    this.vego_seeds = vego_seeds.map((item) => item.handle);
  }
}
if (!customElements.get(`shipping-fee-v0`)) {
  customElements.define(`shipping-fee-v0`, ShippingFeeV0);
}


const CartAreaConst = {
  items: '.cart-area-items',
  pro: '.cart-area-summary',
  note: '.cart-area-note',
  empty: '.cart-area-empty',
  footer: '.cart-area-footer',
}
/**
 * ## Merge products into bundle product in cart drawer
 * Step 1: Geting mapping between product and bundle
 * Step 2: Getting products in cart drawer that can be merged into bundle product
 * Step 3: Merge getted products into bundle product or only update bundle product when bundle product exists in carrt drawer
 * @param {*} items 
 * @returns 
 */
window.transformProductToBundle = async (items = [], disable_action = false) => {
  try {
    //if(!!theme.pathMarketPrefix())return;

    let dataset = (document.querySelector('#CartDrawer').dataset)
    /**
     * # bundle bundle-product_handle-variant
     * {
     *  [bundleHandle]:{
     *    [productHandle]:{
     *      num:Int,
     *      [productColor]: variantId
     *    } 
     *  }
     * }
     */
    let productMap = {},
      /**
       *  # bundle color-variant 
       * 
       * {[bundleHandle]:{
       *  [bundleHandle]: {
       *    [color string]:[variant id ]
       *  }
       * }}
       */
      bundleMap = {},
      /**
       *  # bundle variant-compare_at_price
       * {[bundleHandle]:{
       *  [bundleHandle]: {
       *    [variant id]:[compare price ]
       *  }
       * }}
       */
      bundleComparePriceMap = {},
      /**
      *  # bundle variant-shipping date
      * {[bundleHandle]:{
      *  [bundleHandle]: {
      *    [variant id]:[shipping date ]
      *  }
      * }}
      */
      bundleShippingDateMap = {};
    //{[product-handle]:[ bundle handle1,bundle handle2 ]}
    let productHandles = {}
    let bundleVariantIds = {}
    window.customizeBundles = []
    // Step 1: Geting mapping between product and bundle
    Object.keys(dataset).forEach(key => {
      if (key.startsWith('bundleMap')) {
        let keyData = key.split('__')

        let handle = keyData[1].replace(/_/g, '-')     // index 1: target_bundle handle
        if (!window.customizeBundles.includes(handle)) {
          window.customizeBundles.push(handle)
        }
        let source_handle = keyData[2].replace(/_/g, '-')                  // index 2: source product handle handle
        let variantId = keyData[3]                    // index 2: source product handle id
        // 
        if (!productMap[handle]) productMap[handle] = {}
        //if (!productMap[handle][source_handle]) productMap[handle][source_handle] = {}
        //
        if (!bundleMap[handle]) bundleMap[handle] = {}
        if (!bundleComparePriceMap[handle]) bundleComparePriceMap[handle] = {}
        if (!bundleShippingDateMap[handle]) bundleShippingDateMap[handle] = {}

        if (variantId == 'num') {
          if (!productMap[handle][source_handle]) productMap[handle][source_handle] = {}
          productMap[handle][source_handle].num = dataset[key] // num;
        } else {
          if (key.startsWith('bundleMapProductVariant')) {
            if (!productHandles[source_handle]) productHandles[source_handle] = []
            productHandles[source_handle].push(handle)

            if (!bundleVariantIds[handle]) bundleVariantIds[handle] = []
            bundleVariantIds[handle].push(variantId)
            if (!productMap[handle][source_handle]) productMap[handle][source_handle] = {}
            productMap[handle][source_handle][dataset[key].split(',').sort().join(',')] = variantId;// key.replace(`bundleMapProductVariant-`, '')
          }

          //{[color]:[variantId]}
          if (key.startsWith('bundleMapBundleVariant')) {
            if (!bundleMap[handle][source_handle]) bundleMap[handle][source_handle] = {}

            /**
             * ## special handle for that bundle variant is not correspond with product variant, eg: 
             *  bundle: one option (color only)
             *  1. 4-Pack 17" Tall 10 In 1 Jumbo Modular Metal Raised Garden Bed Kit
             * 
             *  bundle product:  two options (color,size)
             *  1. 17" Tall 10 In 1 Jumbo Modular Metal Raised Garden Bed Kit
             */
            let appendOption = []
            let optionFrist = []
            if (
              handle == `4-pack-17-tall-10-in-1-modular-metal-raised-garden-bed-kit` ||
              handle == `4-pack-32-extra-tall-10-in-1-modular-metal-raised-garden-bed-kit` ||
              handle == `4-pack-11-tall-10-in-1-jumbo-modular-metal-raised-garden-bed-kit`
            ) {
              appendOption = ["2.5' or 4'"]
            }
            if (
              handle == `vego-garden-17-tall-4-in-1-modular-metal-raised-garden-bed-kit-with-cover-system-gen-2`
            ) {
              appendOption = ["VC2050G2 - For 2.0' x 5.0' (4 In 1) Garden Bed"]
            }
            if (
              handle == `17-tall-9-in-1-modular-metal-raised-garden-bed-kit-with-8-pack-dappled-solar-garden-light` ||
              handle == '32-tall-9-in-1-modular-metal-raised-garden-bed-kit-with-8-pack-dappled-solar-garden-light'
            ) {
              appendOption = ["8 Pack"]
            }
            if (handle == `arched-trellis-bundle-2-0-x-6-5`) {
              appendOption = ["VAT15G2 - Single Section 1.5' Long Trellis"]
            }

            if (handle == `wall-trellis-3-5-x-6-5-bundle-garden-bed-trellis`) {
              appendOption = ["VWT65G2 - Five Section 6.5' Long  for 2' x 6.5' or 3.5' x 6.5' Garden Beds"]
            }

            if (handle == `arched-trellis-2-5-x-9-5-bundle-2-garden-beds-trellis`) {
              optionFrist = ["2.5' or 4'"]
              appendOption = ["VAT70G2 - Triple Section 7.0' Long Trellis for 2.5' x 9.5' Garden Beds"]
            }

            if (handle == `arched-trellis-2-0-x-8-0-bundle-2-garden-beds-trellis`) {
              appendOption = ["VAT60G2 - Triple Section 6.0' Long Trellis for 2.0' x 8.0' Garden Beds"]
            }

            let options = dataset[key].split(',');
            options = options.concat(appendOption)

            if (handle == `arched-trellis-2-5-x-9-5-bundle-2-garden-beds-trellis`) {
              options = optionFrist.concat(options)
            }
            bundleMap[handle][source_handle][options.sort().join(',')] = variantId; //key.replace(`bundleMapBundleVariant-`, '')
          }
          //{[variantId]:[price]}
          if (key.startsWith('bundleMapBundleCompareAtPrice')) {
            if (!bundleComparePriceMap[handle][source_handle]) bundleComparePriceMap[handle][source_handle] = {}
            bundleComparePriceMap[handle][source_handle][variantId] = dataset[key]
          }
          if (key.startsWith('bundleMapBundleShippingDate')) {
            if (!bundleShippingDateMap[handle][source_handle]) bundleShippingDateMap[handle][source_handle] = {}
            bundleShippingDateMap[handle][source_handle][variantId] = dataset[key]
          }
        }
      }
    })

    /**
     * {
     * [bundle]:[product num]}
     */

    window.bundle_map_num = {

    }

    Object.keys(productMap).forEach(bundleHandle => {
      let bundleObj = productMap[bundleHandle];
      window.bundle_map_num[bundleHandle] = Object.keys(bundleObj)
        .reduce((res, handle) => {
          res += parseInt(bundleObj[handle].num)
          return res;
        }, 0)
    })
    window.bundleVariantIds = bundleVariantIds
    let tmp_v = Object.values(bundleMap)
    window.bundle_map_num_v2 = tmp_v.reduce((res, item) => {
      Object.keys(item).forEach(handle => {
        Object.values(item[handle]).map(v_id => {
          res[v_id] = window.bundle_map_num[handle]
        })
      })

      return res;
    }, {})


    /**
     *  ##  // Get handle-color-object
     * {
     *  [handle]:{
     *    [color string]:{   [------- notice ------]
     *      color str,
     *      quantity,
     *      list:[Cart Item]  
     *    }
     * }
     * }
     */
    let handle_variant_object = items.reduce((res, item) => {
      //let bundleHandle = productHandles[item.handle]?.[0]
      let itemInBundle = productHandles[item.handle]?.filter?.(handle => bundleVariantIds[handle].includes(`${item.id}`)).flat?.(1).length > 0
      if (productHandles[item.handle]
        && itemInBundle //
        && Object.keys(item.properties).findIndex(key => key.startsWith(`_bundle`)) == -1 // not bundle part
      ) {
        if (!res[item.handle]) res[item.handle] = {}
        let colorStr = item.variant_options.sort().join(',');
        if (!res[item.handle][colorStr]) res[item.handle][colorStr] = {
          //if (!res[item.handle][item.variant_title]) res[item.handle][item.variant_title] = {
          color_str: '',
          quantity: 0,
          list: []
        }
        res[item.handle][colorStr].list.push(item)
        res[item.handle][colorStr].color_str = colorStr // first variant option

        res[item.handle][colorStr].quantity += item.quantity;
      }
      return res;
    }, {})
    if (Object.keys(handle_variant_object).length == 0) return;
    // Calculate Item
    /**
     * {[variant_id]:{
     *  color_str,
     *  handle,
     *  bundleNum,
     * }}
     */
    let list = {},
      /**
       * {
       *  [variant_id]:[number in cart after reduce]
       * }
       */
      idMapNumUpdates = {}, itemsObj = []

    //let color_in_cart = Object.keys(handle_variant_object).map(key => Object.keys(handle_variant_object[key])).flat(1)

    /**
     * Step 2: Getting products in cart drawer that can be merged into bundle product
     */
    Object.keys(productMap).forEach(bundleHandle => {
      /**
       * {[productHandle]:{
       *  num,
       *  [productColor]:[variant id]
       * }}
       */
      let bundleMap = productMap[bundleHandle];
      let bundleMapClone = { ...bundleMap }

      // bundle num array, eg:[1,2]
      let minBundle = [];
      let p_handles = Object.keys(bundleMapClone);
      let selected_variant = []
      let selected_product = {} // matched option
      let res_p_handles = p_handles.filter(bundle_p_handle => {
        // if (`2-pack-retractable-hose-reel-set` == bundleHandle) {
        /**
         * {
         *  num,
         *  [productColor]:[variant id]
         * }
         */
        let p = bundleMapClone[bundle_p_handle]
        let fullfill_items = Object.keys(p).filter((colorStr, index) => {
          if (colorStr != 'num'
            && !selected_product[bundle_p_handle]
          ) {
            if (p.num <= handle_variant_object[bundle_p_handle]?.[colorStr]?.quantity) {
              selected_variant.push(colorStr)
              if (!selected_product[bundle_p_handle]) selected_product[bundle_p_handle] = colorStr
              minBundle.push(Math.floor(handle_variant_object[bundle_p_handle][colorStr]?.quantity / p.num))
              return true
            }
          }
          return false;
        });
        return fullfill_items.length > 0
        // } else {
        //     return false
        // }

      })

      // exist bundle products in cart 
      if (res_p_handles.length == p_handles.length) {
        let bundleNum = Math.min(...minBundle)
        bundleMapClone = { ...bundleMap }
        Object.keys(bundleMapClone).filter((bundle_p_handle, index) => {
          let p = bundleMapClone[bundle_p_handle]
          let selected_variant_str = selected_variant[index]

          let variant_title_object = handle_variant_object[bundle_p_handle]
          idMapNumUpdates[variant_title_object[selected_variant_str].list[0].id] = variant_title_object[selected_variant_str].quantity - (p.num * bundleNum)
          handle_variant_object[bundle_p_handle][selected_variant_str].quantity -= p.num * bundleNum


        })
        /**
         * ## special handling prdouct options that exists in product option of cart page, but not existing in bundle
         */
        if (bundleHandle == 'retractable-hose-reel-set-with-cover') {
          selected_variant = selected_variant.map(item => {
            return item.split(',').filter(item => {
              /**
               * exclude `130 ft`,`130ft or Hi-Flow-100ft Hose Reel` option that not exist in bundle
               */

              return item != '130 ft' && item != '130ft or Hi-Flow-100ft Hose Reel'
            }).join(',')
          })

        } else if (bundleHandle == 'hose-reel-set-green-cover') {
          selected_variant = selected_variant.map(item => {
            return item.split(',').filter(item => {
              /**
               * exclude `130 ft`,`130ft or Hi-Flow-100ft Hose Reel` option that not exist in bundle
               */

              return item != '100 ft' && item != '130ft or Hi-Flow-100ft Hose Reel'
            }).join(',')
          })
        }
        // list.push
        list[bundleHandle] = {
          color_str: selected_variant,
          handle: bundleHandle,
          bundleNum
        }
      }


    })

    // console.log(bundleComparePriceMap, bundleMap, productMap, bundleShippingDateMap, handle_variant_object, window.bundle_map_num,

    //     list,
    //     'list'
    // )

    // * Step 3: Merge getted products into bundle product or only update bundle product when bundle product exists in carrt drawer
    if (Object.keys(list).length >= 1 && !disable_action) {
      try {
        let ids = [], bundleInCart = {} // 购物车中存在的 bundle id,
        let newItems = []
        Object.keys(list).forEach((item) => {
          let handle = list[item].handle
          // 获取和bundle的属性交集
          let insection = [list[item].color_str.sort().join(',')];//.filter(item => Object.keys(bundleMap[handle][handle]).includes(item));//[,]
          if (bundleMap[handle][handle]['Default Title']) {
            insection = ['Default Title']
          }
          let id = bundleMap[handle][handle][insection[0]]; // bundle id  

          ids.push(id)
          let idItem = items.find(item => item.id == id)
          if (!idItem) {  // 购物车中不存在，单独添加
            let shippingDateTime = bundleShippingDateMap[handle][handle][bundleMap[handle][handle][insection[0]]]
            let _shippingDateTime = shippingDateTime
            let shippingDate = `In Stock`;
            if (shippingDateTime) {
              //shippingDate = new Date(1000*shippingDateTime)
              shippingDate = new Date(1000 * shippingDateTime).toDateString().split(' ').slice(1)
              shippingDate[1] = `${parseInt(shippingDate[1])},`
              shippingDate = `Ships by: ` + shippingDate.join(' ')
            }
            //let shippingDate = bundleShippingDateMap[handle][handle][bundleMap[handle][insection[0]]??'In Stock']
            newItems.push({
              id, quantity: list[item].bundleNum,
              shippingDate: shippingDate,
              _shippingDateTime,
              bundleHandle: handle,
              original_price: bundleComparePriceMap[handle][handle][bundleMap[handle][handle][insection[0]]]
            })
          } else {        // 购物车中存在，修改数量
            bundleInCart[id] = idItem.quantity + list[item].bundleNum;
          }
        })

        newItems.forEach((item, index) => {
          itemsObj.push(`items[${index}][id]=${item.id}`)
          itemsObj.push(`items[${index}][quantity]=${item.quantity}`)

          if (item._shippingDateTime && `${item._shippingDateTime}` != '0') {
            itemsObj.push(`items[${index}][properties][_is_fullfillDate]=${item.shippingDate}`)
            itemsObj.push(`items[${index}][properties][_is_fullfillDate_ts]=${item._shippingDateTime}`)
            itemsObj.push(`items[${index}][properties][_is_preorder]=Note: Pre-order item`)
          } else {
            //itemsObj.push(`items[${index}][properties][_is_fullfillDate_ts]=${item._shippingDateTime}`)
            itemsObj.push(`items[${index}][properties][_is_fullfillDate]=In Stock`)
          }
          itemsObj.push(
            `items[${index}][properties][__original_price]=${item.original_price}`,
          );
          itemsObj.push(`items[${index}][properties][__is_bundleProduct]=` + document.querySelector('#CartDrawer').getAttribute(`data-bundle-id__${item.bundleHandle}`))
        })
        // console.log(list, {
        //     ...idMapNumUpdates, // update product 10 in 1 in cart num 
        //     ...bundleInCart,    // update bundle in cart num 
        // })
        // let res = await theme.cart.updateItem({
        //     ...idMapNumUpdates, // update product 10 in 1 in cart num 
        //     ...bundleInCart,    // update bundle in cart num 

        // }) // update items num in cart
        //if (res) {
        // case 1: no bundle exist, add new bundle
        // if (itemsObj.length) {
        //     theme.cart.addCart(itemsObj.join('&'))
        //         .then(() => {
        //             document.dispatchEvent(
        //                 new CustomEvent('ajaxProduct:added', {
        //                     detail: {},
        //                 })
        //             )
        //         })
        // } else if (res) { // case 2: bundle exist in cart
        //     document.dispatchEvent(
        //         new CustomEvent('ajaxProduct:added', {
        //             detail: {},
        //         })
        //     )

        // }
        //} else {
        // failed to transform single-composter to twin-composter
        //}
      } catch (error) {
        console.log(error)
      }
    }
  } catch (error) {
    console.log(`transformProductToBundle Error: ${error}`)
  }
}

const initDiscountEvent = () => {
  //========== BEGIN discount app here
  //discount applied event listener
  document.body.addEventListener('docapp-discount-applied', (e) => {
    if (e.cart) {
      let shippingFee = document.querySelector('shipping-fee-v0')?.calcShippingFee?.({
        items: e.cart.items.map(a => (window.cartDrawerInstance?.cart?.items ?? []).find(b => b.key == a.key||b.variant_id==a.variant_id)).filter(e => e)
      }, true) ?? 0
      let total = theme.Currency.formatMoney(shippingFee + e.cart.items_subtotal_price);
      $('.ajaxcart__price_total').html(total)
      $('.commodity-discount-total-price[data-sub-total]').html(theme.Currency.formatMoney(e.cart.items_subtotal_price))
      $('.grid-product-variant-title__tip_shipping').tooltip()
      window.fixCartExtraSavingAfterDiscount?.(e.discounts, e?.cart?.items ?? [])
    }

  });

  //========== END discount app here

}
theme.CartDrawerConst = {
  /**
   * ## `Free Gift Box`
   *  ## Free Gift Box 启用步骤
   *  1. 修改`FREE_GIFT_BOX_CONFIG` 对应配置
   *  2. 处理`cart`中进度条产品、价格位置. 修改`.free-gift-progress`元素的`data-total`值
   *  3. 显示`.total-saving` 元素, 并修改此处的活动名称
   *  4. 启用`cart-level-promote.liquid`文件
   */
  // Free Gift Box Config
  FREE_GIFT_BOX_CONFIG: {
    handle: "free-herb-planter-box-with-trellis-gift-1",
    levelId: {
      //  礼品varaintId
      // level1: '39964453470243',
      level1: "40751841050659",
      // level2: "41898327408675",
    },
    levelFree: {
      // 赠送礼品价值
      level1: 69,
      // level2: 25,
      // level1: 60,
    },
    levelOrder: {
      // 订单门槛
      // level2: 500,
      level1: 400,
    },
    LevelMsg: {
      // 折扣信息, keep in same with discount, ref: https://admin.shopify.com/store/vego-gardening-store/apps/functions-test-app-5/volume/7924d67d-6a73-480e-80a6-14b7feea8a28/1220789600291
      level1: "EZ Self-Watering Herb Planter $69",
      // level2: "$25",
      // level1: "$15",
    },
  },
};
theme.CartDrawer = (function () {
  
  var selectors = {
    drawer: '#CartDrawer',
    container: '#CartContainer',
    //template: '#CartTemplate',
    cartBubble: '#CartBubble',
    qtySelector: '.js-qty__wrapper',
    cartContainerSelector: '.cart-container',
  }

  var config = {
    namespace: '.ajaxcart',
  }

  function CartDrawer() {
    this.container = document.querySelector(selectors.container);
    this.status = {
      loaded: false,
      loading: false,
    };
    this.drawer = new theme.Drawers("CartDrawer", "cart");
    //this.$procuctCache = {}
    var that = this;
    window.initSoilCaculator?.();
    // Build cart on page load so it's ready in the drawer
    theme.cart.getCart().then(this.buildCart.bind(this));
    document.addEventListener(
      "cart:build",
      function () {
        theme.cart.getCart().then(this.buildCart.bind(this));
      }.bind(this)
    );
    this.discount = theme.config.discountInfo;
    this.initEventListeners();

    // DISCOUNT APP CODE INPUT
    this.initDiscountInput_APP();
  }

  CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
    autoAddtoCart(id, fullfillDate, preOrder, quantity = 1) {
      const item = {
        id: id,
        quantity: quantity,
      };
      const properties = {};
      if (fullfillDate) properties._is_fullfillDate = fullfillDate;
      if (preOrder) properties._is_preorder = 'Note: Pre-order item';
      if (Object.keys(properties).length > 0) {
        item.properties = properties;
      }
      theme.cart.addCart({ items: [item] }).then(() => {
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              addToCartBtn: null,
            },
          }),
        );
      });
    },

    /**
     * ## 订单满足某几个阶段的条件时, 自动加入购物车
     * #### 具体参数配置，请参考price_level_pro,product_level_pro 的eg
     * @param {*} total       total price
     * @param {*} fillTotal   fill condition price
     */
    totalFillAutoAddtoCart(items, totalPrice) {
      const $autoAddtoCart = $(".auto-add-to-cart");
      if (!$autoAddtoCart.length) return;
      let priceRange = $autoAddtoCart
        .data("price")
        .split(",")
        .map((item) => parseInt(item ? item : "0"));
      let productRange = $autoAddtoCart
        .data("product")
        .split(",")
        .map((item) => {
          let handle = item.split(":");
          return {
            handle: handle[0],
            quantity: handle[1] ?? 1,
          };
        });

      // 查找当前总价在某个价格区间的索引
      let index = priceRange.findIndex((price, index) => {
        const nextPrice = priceRange[index + 1] ?? 9999999;
        return totalPrice >= price && totalPrice < nextPrice;
      });

      if (index > -1) {
        let handler = productRange[index].handle;
        if (handler) {
          let selector = `[data-product-handle="${handler}"]`;
          if (!items.find((item) => item.url.includes(handler)) && handler) {
            const $item = $(selector, $(".auto-add-to-cart")).first();
            this.autoAddtoCart(
              $item.find('[name="id"]').val(),
              $item.find('[name="properties[_is_fullfillDate]"]').val(),
              $item.find('[name="properties[_is_preorder]"]').val(),
              productRange[index].quantity,
            );
          }
        }
      }
      // const one_level_price = 799, second_level_price = 999999999;
      // if (totalPrice > one_level_price && totalPrice <= second_level_price) { //
      //   if (!items.find(item => item.url.includes(one_level_handle)) && one_level_handle) {
      //     const $item = $('.auto-add-to-cart .grid__item').first();
      //     this.autoAddtoCart($item.find('[name="id"]').val(), $item.find('[name="properties[_is_fullfillDate]"]').val(), $item.find('[name="properties[_is_preorder]"]').val())
      //   }
      // } else if (totalPrice > second_level_price) {
      //   if (!items.find(item => item.url.includes(second_level_handle)) && second_level_handle) {
      //     const $item = $('.auto-add-to-cart .grid__item').last();
      //     this.autoAddtoCart($item.find('[name="id"]').val(), $item.find('[name="properties[_is_fullfillDate]"]').val(), $item.find('[name="properties[_is_preorder]"]').val())
      //   }
      // }
    },
    /**
     * ## Refresh PaymentTerms
     */
    async refreshPaymentTerms() {
      let res = await fetch(
        `${window.route_prefix}?sections=refresh-payment_terms`,
      );
      res = await res.json();
      let divEle = document.createElement("div");
      divEle.innerHTML = res["refresh-payment_terms"];
      const oldTerms = document.querySelector(
        ".cart-area shopify-payment-terms",
      );
      const newTerms = divEle.querySelector("shopify-payment-terms");
      if (newTerms && oldTerms) {
        oldTerms.replaceWith(newTerms);
      }
    },
    /**
     *
     *  work for `payment term`
     *  shopify-payment-terms
     *
     */
    renderCart() {
      // const that = this
      //if (!document.querySelector(".drawer--is-open"))
      this.refreshPaymentTerms();
      return new Promise((resolve, reject) => {
        //if (!$(that.source).find('shopify-payment-terms').length) {
        // if (that.source.indexOf('shopify-payment-terms') == -1) {
        //   try {
        //     $.get(`${theme.pathMarketPrefix()}/?sections=ajax-cart-template`, function (data) {
        //       that.source = $(data['ajax-cart-template']).find(selectors.template).html()
        //       that.template = Handlebars.compile(that.source)
        //       resolve(that);
        //     })
        //   } catch (e) {
        //     console.log(e)
        //     reject(e)
        //   }
        // } else {
        //   resolve(that);
        // }
        if (!theme.templates["template-cart"].result) {
          theme.loadTemplate("template-cart").then((result) => {
            theme.templates["template-cart"].result = result;
            resolve();
          });
        } else {
          resolve();
        }
      });
    },

    // _autosizeImage(src) {
    //   if (src.includes('_{width}x')) {
    //     return src
    //   }
    //   return src.replace(/\.(jpg|png|jpeg|bmp)/, '_{width}x.$1')
    // },

    // _ajaxProductCallback(data, item) {
    //   var meta = data.product.metafields
    //   var imageMap = data.product.images.reduce(function (a, b) {
    //     a[b.id] = b
    //     return a
    //   }, {})
    //   var variants = [], options = [], optionSelect = [], isFirst = true, variantImages = [], avaliableG1Options = []

    //   for (var i = 0; i < data.product.variants.length; i++) {
    //     var variant = data.product.variants[i]
    //     var variantMeta = meta.variants.find(v => v.id == variant.id)
    //     variant.available = variantMeta.available
    //     var skipVariant = false
    //     // =============  To Display compare_at_price of Ca =========================
    //     //if (variantMeta.compareAtPrice && !variant.compare_at_price && variantMeta.compareAtPrice > variant.price && theme.pathMarketPrefix()) {
    //     if (variantMeta.compareAtPrice) {
    //       variant.compare_at_price = variantMeta.compareAtPrice
    //     } else {
    //       if (`${variant.compare_at_price}`.includes('.')) variant.compare_at_price = ((`${variant.compare_at_price}`.replace(',', '')) * 100).toFixed(0)
    //     }

    //     variant.compare_at_price = theme.unityCompareAtPrice(variant.compare_at_price, variant.id)
    //     if (variant.compare_at_price <= variant.price * 100) {
    //       variant.compare_at_price = null
    //     }
    //     if (variant.title === 'Default Title') {
    //       data.product.hasOnlyDefaultTitle = true
    //     }

    //     if (data.product.options[1] && data.product.options[1].name === 'Bracing Rod Width') {
    //       if (variant.option2 === '4.5\'') {
    //         skipVariant = true
    //       }
    //     }

    //     if (!(variantMeta.spec && variantMeta.spec.hide)) {
    //       if (variantMeta.available) {
    //         if (data.product.options.length === 1) {
    //           var optionLabel = variant.option1.split('-')[0].trim()
    //           if (optionLabel.indexOf('G2') > -1) {
    //             avaliableG1Options.forEach(function (option) {
    //               if (optionLabel.indexOf(option) > -1) {
    //                 skipVariant = true
    //               }
    //             })
    //           } else {
    //             avaliableG1Options.push(optionLabel)
    //           }
    //         }
    //         if (skipVariant) {
    //           continue
    //         }
    //         if (!variant.image_id) {
    //           variant.image_id = data.product.images[0].id
    //         }
    //         variant.image = {
    //           src: imageMap[variant.image_id].src,
    //           srcset: theme.Images.srcSetImages(imageMap[variant.image_id].src),
    //           alt: imageMap[variant.image_id].alt
    //         }
    //         variantImages.push({
    //           src: variant.image.src,
    //           srcset: variant.image.srcset,
    //           alt: variant.image.alt,
    //           id: variant.id
    //         })
    //         if (variantMeta.preOrder) {
    //           if (variantMeta.preOrder.toLowerCase() === 'true') {
    //             variant.preOrder = true
    //             // variant.fulfillmentDate = formatDateText(variantMeta.estimatedFulfillmentDateTs * 1000, 'DD/MM/YYYY')
    //             variant.fulfillmentDate = ts2shortDateFormat(variantMeta.estimatedFulfillmentDateTs * 1000)
    //           }
    //         } else {
    //           if (meta.preOrder && meta.preOrder.toLowerCase() === 'true') {
    //             variant.preOrder = true
    //             // variant.fulfillmentDate = formatDateText(meta.estimatedFulfillmentDateTs * 1000, 'DD/MM/YYYY')
    //             variant.fulfillmentDate = ts2shortDateFormat(meta.estimatedFulfillmentDateTs * 1000)
    //           }
    //         }
    //         if (variantMeta.estimatedFulfillmentDateTs) {
    //           variant.fulfillmentDateTs = variantMeta.estimatedFulfillmentDateTs
    //         }
    //         for (var j = 1; j < 4; j++) {
    //           if (variant['option' + j]) {
    //             if (!options[j - 1]) {
    //               options[j - 1] = []
    //             }
    //             if (options[j - 1].indexOf(variant['option' + j]) == -1) {
    //               options[j - 1].push(variant['option' + j])
    //             }
    //             if (item.variantId) {
    //               if (variant.id == item.variantId) {
    //                 optionSelect[j - 1] = variant['option' + j]
    //               }
    //             } else if (isFirst) {
    //               optionSelect[j - 1] = variant['option' + j]
    //             }
    //           }
    //         }
    //         if (item.variantId) {
    //           if (variant.id == item.variantId) {
    //             data.product.select = variant
    //           }
    //         } else if (isFirst) {
    //           data.product.select = variant
    //           isFirst = false
    //           if (this.discount && this.discount[variant.id]) {
    //             var discount = this.discount[variant.id]
    //             if (discount.discountPercent) {
    //               data.product.discount = discount.discountPercent + '% OFF'
    //             } else if (discount.discountValue) {
    //               data.product.discount = 'SAVE $' + discount.discountValue
    //             }
    //           }
    //         }
    //         variants.push(variant)
    //       }
    //     }
    //   }
    //   if (data.product.select) {
    //     data.product.available = true
    //   }
    //   if (!variants.length) {
    //     return null
    //   }
    //   data.product.variants = variants
    //   data.product.variantImages = variantImages
    //   options.forEach(function (o, i) {
    //     var option = data.product.options[i]
    //     if (option) {
    //       option.values = o
    //       option.select = optionSelect[i]
    //       if (option.name === 'Bracing Rod Width'
    //         && data.product.handle !== '11-tall-2-extension-kit-for-10-in-1-raised-garden-bed'
    //         && data.product.handle !== '17-tall-vego-garden-2-ft-extension-kit'
    //         && data.product.handle !== '32-tall-2-extension-kit-for-10-in-1-raised-garden-bed') {
    //         option.hide = true
    //       }
    //     }
    //   })
    //   data.product.variantJson = JSON.stringify(data.product.variants)
    //   data.product.image.srcset = theme.Images.srcSetImages(data.product.image.src)
    //   if (data.product.select.preOrder) {
    //     data.product.fulfillmentDate = data.product.select.fulfillmentDate
    //     data.product.fulfillmentDateTs = data.product.select.fulfillmentDateTs
    //   }
    //   data.product.singlePrice = theme.Currency.formatMoney(
    //     data.product.select.price,
    //     theme.settings.moneyFormat
    //   )
    //   data.product.compareAtPrice = theme.Currency.formatMoney(
    //     data.product.select.compare_at_price ?? 0,
    //     theme.settings.moneyFormat
    //   )
    //   data.product.compareAtPriceValue = (data.product.select.compare_at_price ?? 0) / 100
    //   return data
    // },

    /**
     * you might also like
     * @param {} list
     */

    updateBundleVariant(item, product) {
      var ret = product;
      var meta = product.metafields;
      var imageMap = ret.images.reduce(function (a, b) {
        a[b.id] = b;
        return a;
      }, {});
      ret.icon =
        "https://cdn.shopify.com/s/files/1/0286/2271/6963/files/B_d6cdf95a-9146-46af-9b55-35325bbfdad0.png?v=1676253668";
      var variants = [],
        options = [],
        optionSelect = [],
        isFirst = true,
        variantImages = [];
      ret.variants.forEach((v, index) => {
        if (v.title === "Default Title") {
          ret.hasOnlyDefaultTitle = true;
        }
        var variantMeta = meta.variants[index];
        if (variantMeta.preOrder) {
          if (variantMeta.preOrder.toLowerCase() === "true") {
            v.preOrder = true;
            v.fulfillmentDate = variantMeta.estimatedFulfillmentDate;
          }
        } else {
          if (meta.preOrder && meta.preOrder.toLowerCase() === "true") {
            v.preOrder = true;
            v.fulfillmentDate = meta.estimatedFulfillmentDate;
          }
        }
        if (variantMeta.estimatedFulfillmentDateTs) {
          v.fulfillmentDateTs = variantMeta.estimatedFulfillmentDateTs;
        }
        v.available = variantMeta.available;
        if (v.available) {
          if (v.image_id) {
            v.image = {
              src: imageMap[v.image_id].src,
              srcset: theme.Images.srcSetImages(imageMap[v.image_id].src),
              alt: imageMap[v.image_id].alt,
            };
            variantImages.push({
              src: v.image.src,
              alt: v.image.alt,
              id: v.id,
            });
          }
        }
        if (item.variantDiscount) {
          if (item.variantDiscount[v.id]) {
            if (v.available) {
              variants.push(v);
              for (var i = 1; i < 4; i++) {
                if (v["option" + i]) {
                  if (!options[i - 1]) {
                    options[i - 1] = [];
                  }
                  if (options[i - 1].indexOf(v["option" + i]) == -1) {
                    options[i - 1].push(v["option" + i]);
                  }
                  if (isFirst) {
                    optionSelect[i - 1] = v["option" + i];
                  }
                }
              }
              if (isFirst) {
                ret.select = v;
                isFirst = false;
              }
              v.bundleDiscount = item.variantDiscount[v.id];
              v.savePrice = theme.Currency.formatMoney(
                (v.price - v.bundleDiscount) * 100,
                theme.settings.moneyFormat,
              );
            }
          }
        } else {
          if (v.available) {
            variants.push(v);
            for (var i = 1; i < 4; i++) {
              if (v["option" + i]) {
                if (!options[i - 1]) {
                  options[i - 1] = [];
                }
                if (options[i - 1].indexOf(v["option" + i]) == -1) {
                  options[i - 1].push(v["option" + i]);
                }
                if (isFirst) {
                  optionSelect[i - 1] = v["option" + i];
                }
              }
            }
            if (isFirst) {
              console.log(v);
              ret.select = v;
              isFirst = false;
            }
            v.bundleDiscount = item.discount;
            v.savePrice = theme.Currency.formatMoney(
              (v.price - v.bundleDiscount) * 100,
              theme.settings.moneyFormat,
            );
          }
        }
      });
      if (!variants.length) {
        return null;
      }
      ret.variants = variants;
      ret.variantImages = variantImages;
      ret.variantJson = JSON.stringify(variants);
      options.forEach(function (o, i) {
        if (ret.options[i]) {
          ret.options[i].values = o;
          ret.options[i].select = optionSelect[i];
        }
      });
      if (ret.select.preOrder) {
        ret.fulfillmentDate = ret.select.fulfillmentDate;
      }
      if (item.quantity) {
        ret.quantity = item.quantity;
      } else {
        ret.quantity = 1;
      }
      return ret;
    },

    pascalCase(str) {
      return str
        .replace(/(\w)(\w*)/g, function (g0, g1, g2) {
          return g1.toUpperCase() + g2.toLowerCase();
        })
        .replaceAll("-", " ");
    },

    initEventListeners: function () {
      let that = this;
      document.addEventListener("visibilitychange", function () {
        //
        if (document.visibilityState == "visible") {
          // tab active
          theme.cart.getCart().then(function (cart) {
            that.buildCart(cart, false, null);
          });
        }
      });

      document.addEventListener(
        "updateCart" + config.namespace,
        this.initQtySelectors.bind(this),
      );
      document.addEventListener(
        "updateCart" + config.namespace,
        this.updateCartNotification.bind(this),
      );
      //console.log('------->>>>>', `ajaxProduct:added`)
      document.addEventListener(
        "ajaxProduct:added",
        function (evt) {
          var that = this;
          theme.cart.getCart().then(function (cart) {
            that.buildCart(
              cart,
              evt?.detail.drawer == 0 ? false : true,
              evt?.detail?.addToCartBtn
            );
          });
        }.bind(this)
      );
    },

    updateCartCount: function (numQty) {
      //qty of cart-withdraw
      $(".drawer__title span").html(`(${numQty})`);
      //qty of nav cart icon
      $(".cart-link__bubble").map((index, item) => {
        $(item).html(numQty);
      });
    },

    itemLabel(url) {
      if (url.includes(`worm-farm-worm-composter`)) return "Set";
      if (url.includes(`garden-bed-cover-systems`)) return "Configuration";
      return "Color";
    },
    /***
     * ## Campaign: 购物顶部显示满足条件的商品
     */
    doCartTip(total, variantIds) {
      const ids = [`39869961764899`, `39869961797667`, `39869961830435`];
      const prices = [`39.95`, `69.95`, `99.95`];

      let res = theme.judgeDiscount(total);
      const id = "pro-container";
      const range = [28900, 468900, 59900];

      if (res.index > -1) {
        let variantId = ids[res.index];
        if (variantIds.indexOf(variantId) == -1) {
          $(`.${id}`).show();
          $(`.${id} [name="id"]`).val(variantId);
          $(`.${id} .pro-form-info span:first-child`).html(
            `${(res.index + 1) * 2} Pack`,
          );
          $(`.${id} .pro-form-info span:last-child`).html(
            `$${prices[res.index]}`,
          );
        } else if (
          total > range[res.index] - prices[res.index] * 100 &&
          total < range[res.index]
        ) {
          $(`.${id}`).show();
          $(`.${id} [name="id"]`).val(variantId);
          $(`.${id} .pro-form-info span:first-child`).html(
            `${(res.index + 1) * 2} Pack`,
          );
          $(`.${id} .pro-form-info span:last-child`).html(
            `$${prices[res.index]}`,
          );
        } else {
          $(`.${id}`).hide();
        }
      } else {
        $(`.${id}`).hide();
      }
      const t = document.querySelector(".vego-prompt-items").clientHeight;
      let clappse = t == 84;
      let $curentEle = $(
        `.vego-prompt-items [name="id"][value="${
          ids[res.index + 1] || ids[2]
        }"]`,
      ).closest("div");

      if (!clappse) {
        $curentEle.siblings().hide();
      } else {
        $curentEle.siblings().show();
      }
      $curentEle.show();
      theme.resizeCart();
    },
    activityType: {
      FREE_BOX: "free-box",
      FREE_BOX_AND_UPDATE_PRICE: "free-box-update-price",
      BOGO_AND_UPDATE_PRICE: "bogo-update-price",
      BOGO: "bogo",
      UPDATE_PRICE: "update-price",
      SHOPIFY_DISCOUNT: "shopify-discount",
      BUY_GARDEN_BEDS_FREE_LIGHT: "buy-garden-beds-free-2-light",
      BUY_GARDEN_BEDS_FREE_LIGHT_UPDATE_PRICE:
        "buy-garden-beds-free-2-light-update-price",
      FREE_30_FOR_150_ORDER_VALUE: "150-free-30",
    },
    /**
     * ## `Free Gift Box`
     * ### 清除Free Gift Box 进度条产品的`加购`和`已加入购物车`按钮
     */
    clearGiftCheckedStatus() {
      [...document.querySelectorAll(".free-gift-progress-pic > span")].forEach(
        (el) => {
          el.classList = "";
        },
      );
    },

    /**
     * ## `Free Gift Box`
     *  ## Free Gift Box 启用步骤
     *  1. 修改`FREE_GIFT_BOX_CONFIG` 对应配置
     *  2. 处理`cart`中进度条产品、价格位置. 修改`.free-gift-progress`元素的`data-total`值
     *  3. 显示`.total-saving` 元素, 并修改此处的活动名称
     *  4. 启用`cart-level-promote.liquid`文件
     */
    // Free Gift Box Config
    // FREE_GIFT_BOX_CONFIG: {
    //   handle: "mini-planter-gift-box",
    //   levelId: {
    //     //  礼品varaintId
    //     // level1: '39964453470243',
    //     level1: '40251254702115',
    //     level2: '40246461726755',

    //   },
    //   levelFree: { // 赠送礼品价值
    //     level1: 80,
    //     level2: 120,
    //     // level1: 60,
    //   },
    //   levelOrder: { // 订单门槛
    //     level2: 500,
    //     level1: 350,
    //   },
    //   LevelMsg: {
    //     // 折扣信息, keep in same with discount, ref: https://admin.shopify.com/store/vego-gardening-store/apps/functions-test-app-5/volume/7924d67d-6a73-480e-80a6-14b7feea8a28/1220789600291
    //     // level1: 'Seedlings $25',
    //     level2: 'Tomato Planter',
    //     level1: 'Herb Planter',
    //   }
    // },
    /**
     * Buy Garden Beds Free 2 Light
     */
    campaignBuyGardenBedsFreeLight(items) {
      /**
       * =================================================================
       *            == Notice: variant_id 需根据活动设置===
       * =================================================================
       */
      const variant_id = "39869961764899"; // Solar Garden Light 2 Pack
      let quantity = 0;
      let hasGardeBeds = items.filter((item) => {
        if (vgBeds.indexOf(`${item.handle}`) > -1) {
          quantity += item.quantity;
          return true;
        } else if (variant_id == `${item.variant_id}`) {
          quantity -= item.quantity;
        }
        return false;
      });
      if (hasGardeBeds.length && quantity > 0) {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [{ id: variant_id, quantity: 1 }] }),
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((err) => {
                throw err;
              });
            }
            return response.json();
          })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  addToCartBtn: null,
                },
              }),
            );
          });
      }
    },
    campaignFreeGiftBoxAmount(discounts, cartItems) {
      let pEL = document.querySelector(
        ".free-gift-box .gift-box-information p",
      );
      let discount_account = cartItems.find((item) =>
        item.discounts.find((item) => item.title == "Saving"),
      );
      let elProgress = document.querySelector(".free-gift-progress");
      if (!elProgress) {
        let fgbEL = document.querySelector(".free-gift-box");
        if (fgbEL) fgbEL.style.display = "flex";
        return;
      }
      let total = parseInt(elProgress.dataset.total);
      let cartTotal = parseInt(elProgress.dataset.cartTotal);
      let current = 0;
      let _cartTotal = cartTotal;
      if (cartTotal > total) {
        cartTotal = total;
        current = 100;
      } else {
        _cartTotal = cartTotal;
        current = (_cartTotal / total) * 100;
      }
      if (current > 100) current = 100;

      let needSpace = elProgress.querySelector(".free-total-fill");
      elProgress.querySelector(".free-fill").style.width = current + "%";

      if (
        cartTotal <
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 &&
        !discount_account
      ) {
        needSpace.style.width =
          ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
            _cartTotal) /
            total) *
            100 +
          "%";
        pEL.innerHTML = `You're only <b>$${(
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
          cartTotal
        ).toFixed(0)}</b> away from free <span>${
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level1
        } Gift</span>!`;
        this.unloading();
        this.clearGiftCheckedStatus();
        this.keepOnlyOneFreeGiftBox(cartItems).then((res) => {
          if (res) {
            this.updateSuccess(res);
          }
        });
        // } else if (
        //   cartTotal < theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2
        // ) {
        //   needSpace.style.width =
        //     ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
        //       cartTotal) /
        //       total) *
        //       100 +
        //     "%";

        //   let priceLevel = (
        //     theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
        //     cartTotal
        //   ).toFixed(0);
        //   pEL.innerHTML = `${`You\'ve just unlocked discount $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level1}. `} Add <b>$${priceLevel}</b> more to your cart to receive discount <b>$${
        //     theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2
        //   }</b>.`;
        //   // } else if (cartTotal >= theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2) {
        //   //   let res = (100 - current)
        //   //   needSpace.style.width = res + '%';
        //   //   pEL.innerHTML = `You've just unlocked discount $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2}.`;
        //   //   document.querySelector('.free-gift-progress-pic>a').classList = ''
      } else {
        needSpace.style.width = "0%";
        document.querySelector(
          ".free-gift-progress-pic>span,.free-gift-progress-pic>a",
        ).classList = "active1 active-added";
        pEL.innerHTML = `Congrats! You've unlocked it with your order.`;
        this.keepOnlyOneFreeGiftBox(cartItems).then((res) => {
          if (res) {
            this.updateSuccess(res);
          }
        });
      }
      pEL.closest(".free-gift-box").style.display = "block";

      theme.setCartHeightOfMainContent();
    },
    campaignFreeGiftBoxAmount(discounts, cartItems) {
      let pEL = document.querySelector(
        ".free-gift-box .gift-box-information p",
      );
      let discount_account = cartItems.find((item) =>
        item.discounts.find((item) => item.title == "Saving"),
      );
      let elProgress = document.querySelector(".free-gift-progress");
      if (!elProgress) {
        let fgbEL = document.querySelector(".free-gift-box");
        if (fgbEL) fgbEL.style.display = "flex";
        return;
      }
      let total = parseInt(elProgress.dataset.total);
      let cartTotal = parseInt(elProgress.dataset.cartTotal);
      let current = 0;
      let _cartTotal = cartTotal;
      if (cartTotal > total) {
        cartTotal = total;
        current = 100;
      } else {
        _cartTotal = cartTotal;
        current = (_cartTotal / total) * 100;
      }
      if (current > 100) current = 100;

      let needSpace = elProgress.querySelector(".free-total-fill");
      elProgress.querySelector(".free-fill").style.width = current + "%";

      if (
        cartTotal <
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 &&
        !discount_account
      ) {
        needSpace.style.width =
          ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
            _cartTotal) /
            total) *
            100 +
          "%";
        pEL.innerHTML = `You're only <b>$${(
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
          cartTotal
        ).toFixed(0)}</b> away from free <span>${
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level1
        } Gift</span>!`;
        this.unloading();
        this.clearGiftCheckedStatus();
        this.keepOnlyOneFreeGiftBox(cartItems).then((res) => {
          if (res) {
            this.updateSuccess(res);
          }
        });
        // } else if (
        //   cartTotal < theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2
        // ) {
        //   needSpace.style.width =
        //     ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
        //       cartTotal) /
        //       total) *
        //       100 +
        //     "%";

        //   let priceLevel = (
        //     theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
        //     cartTotal
        //   ).toFixed(0);
        //   pEL.innerHTML = `${`You\'ve just unlocked discount $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level1}. `} Add <b>$${priceLevel}</b> more to your cart to receive discount <b>$${
        //     theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2
        //   }</b>.`;
        //   // } else if (cartTotal >= theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2) {
        //   //   let res = (100 - current)
        //   //   needSpace.style.width = res + '%';
        //   //   pEL.innerHTML = `You've just unlocked discount $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2}.`;
        //   //   document.querySelector('.free-gift-progress-pic>a').classList = ''
      } else {
        needSpace.style.width = "0%";
        document.querySelector(
          ".free-gift-progress-pic>span,.free-gift-progress-pic>a",
        ).classList = "active1 active-added";
        pEL.innerHTML = `Congrats! You've unlocked it with your order.`;
        this.keepOnlyOneFreeGiftBox(cartItems).then((res) => {
          if (res) {
            this.updateSuccess(res);
          }
        });
      }
      pEL.closest(".free-gift-box").style.display = "block";

      theme.setCartHeightOfMainContent();
    },
    /**
     * update discount amount progress by orders value
     * @param {*} cartItems
     * @returns
     */
    campaignDiscountAmountOnOrdersValue(cartItems) {
      let exclude_products = [
        "vegotabs",
        "carbon-refill-kit",
        "free-vego-hose-reel-cover-gift",
        "carbon-filter-refill-kit-vegotab-bundle",

        // scratch-dent
        // "17-tall-9-in-1-large-modular-metal-raised-garden-bed-kit-scratch-dent",
        // "32-extra-tall-9-in-1-large-modular-metal-raised-garden-bed-kit-scratch-dent",
        // "vego-kitchen-composter-scratch-dent",
        // "scratch-dent-32-extra-tall-41-wide-extension-kit-for-modern-pro-raised-garden-beds",
        // "scratch-dent-vego-soil-saving-intermediate-floor-for-32-tall-modern-garden-bed",

        // price drop
       

        // Extra $100 Off Select Greenhouses with Code VEGH

      ];
      let exclude_discount_value = 0; // exclude discount value of other discount's
      let discount_code = "LABORDAY";
      let exclude_total_ = cartItems.reduce((res, item, index) => {
        if (item.discounts.length) {
          item.discounts.forEach((element) => {
            if (
              element.title.toLowerCase() != discount_code.toLowerCase() &&
              !exclude_products.includes(item.handle)
            )
              exclude_discount_value += element.amount;
          });
        }
        if (exclude_products.includes(item.handle)) {
          res += item.line_price / 100;
        }
        return res;
      }, 0);
      let pEL = document.querySelector(
        ".free-gift-box .gift-box-information p",
      );
      // let discount_account = cartItems.find((item) =>
      //   item.discounts.find((item) => item.title == "Saving"),
      // );
      let elProgress = document.querySelector(".free-gift-progress");
      if (!elProgress) {
        let fgbEL = document.querySelector(".free-gift-box");
        if (fgbEL) fgbEL.style.display = "flex";
        return;
      }
      let total = parseInt(elProgress.dataset.total);
      // console.log(exclude_discount_value);
      let cartTotal =
        parseFloat(elProgress.dataset.cartTotal) -
        exclude_total_ +
        exclude_discount_value / 100;
      let current = 0;
      let _cartTotal = cartTotal;
      if (cartTotal > total) {
        cartTotal = total;
        current = 100;
      } else {
        _cartTotal = cartTotal;
        current = (_cartTotal / total) * 100;
      }
      if (current > 100) current = 100;

      let needSpace = elProgress.querySelector(".free-total-fill");
      elProgress.querySelector(".free-fill").style.width = current + "%";

      if (
        cartTotal < theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1
      ) {
        needSpace.style.width =
          ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
            _cartTotal) /
            total) *
            100 +
          "%";
        pEL.innerHTML = `You're only <b>$${(
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
          cartTotal
        ).toFixed(2)}</b> away from saving <span>$${
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level1
        }</span>!`;
        this.unloading();
        // this.clearGiftCheckedStatus();
      } else if (
        cartTotal < theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2
      ) {
        needSpace.style.width =
          ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
            cartTotal) /
            total) *
            100 +
          "%";

        let priceLevel = (
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
          cartTotal
        ).toFixed(2);
        pEL.innerHTML = `${`You\'ve just unlocked discount $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level1}. `} Add <b>$${priceLevel}</b> more to your cart to receive discount <span>$${
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2
        }</span>.`;
        // } else if (cartTotal >= theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2) {
        //   let res = (100 - current)
        //   needSpace.style.width = res + '%';
        //   pEL.innerHTML = `You've just unlocked discount $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2}.`;
        //   document.querySelector('.free-gift-progress-pic>a').classList = ''
      } else {
        needSpace.style.width = "0%";
        document.querySelector(
          ".free-gift-progress-pic>span,.free-gift-progress-pic>a",
        ).classList = "active1 active-added";
        pEL.innerHTML = `Congrats! You've unlocked it with your order.`;
      }
      pEL.closest(".free-gift-box").style.display = "block";

      theme.setCartHeightOfMainContent();
    },
    /**
     * ## `Free Gift Box`
     * ### calculate promote level
     * 1. 更新Free Gift Box 活动购物车中礼品卡的进度条
     * 2. 礼品卡是否加入购物车
     * 3. 是否需要显示`加购`图标,
     * 4. 是否需要自动将满足条件的Free Gift Box 加入购物车
     */
    campaignFreeGiftBox(discounts, cartItems) {
      let elProgress = document.querySelector(".free-gift-progress");
      let total = parseInt(elProgress.dataset.total);
      let cartTotal = parseInt(elProgress.dataset.cartTotal);
      //let cartTotalWidthGiftBox = parseInt(elProgress.dataset.cartTotalWithGiftbox);

      const level1 = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level1;
      const level2 = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level2;
      // const level3 = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level3;

      let level1El = document.querySelector(
        `.ajaxcart__product-name--wrapper .ajaxcart__product-name[href*="${level1}"]`,
      );
      let level2El = document.querySelector(
        `.ajaxcart__product-name--wrapper .ajaxcart__product-name[href*="${level2}"]`,
      );
      // let level3El = document.querySelector(`.ajaxcart__product-name--wrapper .ajaxcart__product-name[href*="${level3}"]`);
      let current = 0;
      let _cartTotal = cartTotal;

      let start_amount = 0; // 进度条相对的起点金额

      //
      if (cartTotal > total) {
        cartTotal = total;
        current = 100;
      } else {
        _cartTotal = cartTotal;
        // if(_cartTotal<350){
        //   _cartTotal = 20
        // }else if(_cartTotal >= 350 && _cartTotal<550){
        //   _cartTotal -= 250
        // }else{
        //   _cartTotal -= 250
        // }
        // if (_cartTotal > 550) {
        //   _cartTotal += start_amount
        //   current = (((_cartTotal / total) * 100));
        // } else if (_cartTotal < 350 && _cartTotal > start_amount) {

        //   _cartTotal -= start_amount
        //   current = (((_cartTotal / total) * 100));
        // // } else {
        // //   current = (_cartTotal / total) * 100
        // }
        current = (_cartTotal / total) * 100;
        if (_cartTotal > 400) {
          current = (1350 / total) * 100;
        }
      }
      if (current > 100) current = 100;

      let needSpace = elProgress.querySelector(".free-total-fill");

      let pEL = document.querySelector(
        ".free-gift-box>.gift-box-information>p",
      );
      let applied1Discount = discounts.filter(
        (item) =>
          item.title.indexOf(
            theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level1,
          ) > -1 &&
          item.title !=
            theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level1,
      ).length;
      let applied2Discount = discounts.filter(
        (item) =>
          item.title.indexOf(
            theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level2,
          ) > -1 &&
          item.title !=
            theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level2,
      ).length;
      // let applied3Discount = discounts.filter(item => item.title.indexOf(theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level3) > -1).length;
      elProgress.querySelector(".free-fill").style.width = current + "%";
      let self = this;
      if (
        cartTotal < theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1
      ) {
        needSpace.style.width =
          ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
            _cartTotal) /
            total) *
            100 +
          "%";
        pEL.innerHTML = `Almost there! Add <b>$${(
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 -
          cartTotal
        ).toFixed(0)}</b> more to your cart to receive the <b>${
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level1
        } Gift</b>.`;
        this.unloading();
        this.clearGiftCheckedStatus();
        this.keepOnlyOneFreeGiftBox(cartItems).then((res) => {
          if (res) {
            setTimeout(self.updateSuccess(res), 200);
          }
        });
      } else if (
        cartTotal < theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2
      ) {
        //elProgress.querySelector('.free-fill').style.width = (current)+ '%';

        needSpace.style.width =
          ((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
            cartTotal) /
            total) *
            100 +
          "%";

        let priceLevel = (
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 -
          cartTotal
        ).toFixed(0);
        //Click + icon to add to your cart.
        pEL.innerHTML = `${
          !applied1Discount
            ? `You\'ve just unlocked free $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level1} Gift. `
            : "Almost there!"
        } Add <b>$${priceLevel}</b> more to your cart to receive the <b>${
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level2
        } Gift</b>.`;
        this.updateGiftCheckedStatus(
          level1El,
          1,
          { applied1Discount },
          level1,
          cartTotal,
          cartItems,
        );

        // } else if (cartTotal < theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2) {
        //   console.log('debugger', theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2, cartTotal, total)
        //   //elProgress.querySelector('.free-fill').style.width = (current )+ '%';
        //   needSpace.style.width = ((((theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 - cartTotal) / total) * 100)) + '%';
        //   let levelPrice = (theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2 - cartTotal).toFixed(0)
        //   // Click + icon to add to your cart.
        //   pEL.innerHTML = `${!applied2Discount ? `You\'ve just unlocked free $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2} Gift.` : 'Almost there!'} Add <b>$${levelPrice}</b> more to your cart to receive the free <b>$${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2}</b> Seedlings.`;
        //   this.updateGiftCheckedStatus(level2El, 2, { applied2Discount, applied1Discount }, level2, cartTotal, cartItems)
      } else if (
        cartTotal >=
        theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2
      ) {
        //cartTotal += 200;
        let res = 100 - current;
        needSpace.style.width = res + "%";
        // Click + icon to add to your cart.
        pEL.innerHTML = applied2Discount
          ? `You have received a free $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2} Gift.`
          : `You've just unlocked free $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level2} Gift.`;
        this.updateGiftCheckedStatus(
          level2El,
          2,
          { applied2Discount, applied2Discount, applied1Discount },
          level2,
          cartTotal,
          cartItems,
        );
        document.querySelector(
          ".free-gift-progress-pic>span,.free-gift-progress-pic>a",
        ).classList = "";
      } else {
        needSpace.style.width = "0%";
        document.querySelector(
          ".free-gift-progress-pic>span,.free-gift-progress-pic>a",
        ).classList = "active1 active-added";
        pEL.innerHTML = `You have received a free $${theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelFree.level1} Gift.`;
        //this.clearGiftCheckedStatus()

        this.keepOnlyOneFreeGiftBox(cartItems).then((res) => {
          if (res) {
            setTimeout(self.updateSuccess(res), 200);
          }
        });
      }
      pEL.parentElement.style.display = "block";
    },
    /***
     * ## `Free Gift Box`
     * 1. 礼品卡是否加入购物车
     * 2. 是否需要显示`加购`图标,
     * 3. 是否需要自动将满足条件的Free Gift Box 加入购物车
     */
    updateGiftCheckedStatus(
      levelEl,
      index,
      appliedDiscount,
      levelId,
      total,
      cartItems,
    ) {
      this.keepOnlyOneFreeGiftBox(cartItems).then((res) => {
        // 判断当前在使用的Free Gift Box折扣是第几层级
        if (res && res.items) {
          cartItems = res.items;
        }
        let hasAddItem = false;
        let indexStr = "idex";
        let giftExistedInCart = !!cartItems.filter(
          (item) => item.variant_id == levelId,
        ).length;
        // const enableCartLevelSingle =
        //   document.querySelector("#CartDrawer").dataset
        //     .enable_cart_level_single == "true";
        if (Object.values(appliedDiscount).filter((item) => item).length) {
          appliedDiscount[`applied${indexStr}Discount`] = 1;
        }
        Array.from(
          document.querySelectorAll(".free-gift-progress-pic >span"),
        ).forEach((el, idex) => {
          el.classList = [
            idex == index - 1 ? `active1` : "",
            index > idex ? "active-added" : "",
          ].join(" ");
          /**
           * 依据用户交互，判断是否需要
           */
          if (
            idex == index - 1 &&
            !appliedDiscount[`applied${idex + 1}Discount`] &&
            !giftExistedInCart
          ) {
            hasAddItem = true;
            this.loading(true);
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ items: [{ id: levelId, quantity: 1 }] }),
            })
              .then((response) => {
                if (!response.ok) {
                  return response.json().then((err) => {
                    throw err;
                  });
                }
                return response.json();
              })
              .then((cart) => {
                this.loading(false);
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      addToCartBtn: null,
                    },
                  }),
                );
              });
          }
        });

        let selected_els = Array.from(
          document.querySelectorAll(
            ".free-gift-progress-pic span.active-added",
          ),
        );
        if (selected_els.length > 1) {
          selected_els.slice(0, -1).forEach((el) => {
            el.classList.remove("active-added");
          });
        }
        this.loading(false);
        if (res && !hasAddItem) {
          this.updateSuccess(res);
        }
      });
    },
    existNoneDiscountGiftBox(cartItems) {
      const level1 = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level1;
      // const level2 = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level2;
      // const level3 = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level3;
      // 没有折扣的FreeGiftBox
      if (cartItems) {
        let noneDiscountGiftBoxes = cartItems.filter(
          (item) =>
            [
              level1,
              //, level2, level3
            ].includes(`${item.variant_id}`) &&
            !item.discounts.find(
              (item) =>
                item.title.indexOf(
                  theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level1,
                ) > -1,
              //  || item.title.indexOf(theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level2) > -1 || item.title.indexOf(theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level3) > -1
            ),
        );
        return noneDiscountGiftBoxes;
      }
      return [];
    },
    /**
     * ## `Free Gift Box`
     * ## Free Gift Box 活动，只保留应用打折的Free Gift Box 产品
     */
    keepOnlyOneFreeGiftBox(cartItems) {
      return new Promise((resolve, reject) => {
        // 没有折扣的FreeGiftBox

        // let noneDiscountGiftBoxes = this.existNoneDiscountGiftBox(cartItems)
        let that = this;
        const level1 =
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level1;
        const level2 =
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level2;
        // const level3 = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level3;
        // resolve(false)
        let noneDiscountGiftBoxes = cartItems.filter(
          (item) =>
            [level1, level2].includes(`${item.variant_id}`) && //&&
            !item.discounts.length,
          // !item.discounts.find(
          //   (item) =>
          //     item.title.indexOf(
          //       theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level1
          //     ) > -1 ||
          //     item.title.indexOf(
          //       theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.LevelMsg.level2
          //     ) > -1
          // )
        );
        //console.log(noneDiscountGiftBoxes)
        setTimeout(() => {
          if (noneDiscountGiftBoxes.length) {
            that.loading(true);
            // 保持一个free box
            theme.cart
              .updateItem(
                noneDiscountGiftBoxes.reduce((res, item) => {
                  res[item.id] = 0;
                  return res;
                }, {}),
              )
              .then(
                function (cart) {
                  resolve(cart);
                  that.loading(false);
                }.bind(that),
              )
              .catch(
                function (XMLHttpRequest) {
                  that.loading(false);
                }.bind(that),
              );
            //resolve(false)
          } else {
            resolve(false);
          }
        });
        //  resolve(false)
      }, 500);
    },
    /**
     *  ## Transform single composter to twin, refer below rules:
     *  3 single composter -> 1 single composter, 1 twin composter
     *  4 single composter -> 2 twin composter
     *  5 single composter -> 2 twin composter, 1 single composter
     *  ....
     */
    transformSingleToComposterTwin: async (items = []) => {
      let quantity = 0,
        singleComposterId = "39647044567075",
        twinComposterId = "39647044599843";
      items.forEach((item) => {
        let variantId = item.variant_id;
        if (
          variantId == singleComposterId &&
          Object.keys(item.properties).findIndex((key) =>
            key.startsWith(`_bundle`),
          ) == -1 // not bundle part
        ) {
          quantity += item.quantity;
        }
      }, {});
      if (quantity >= 2) {
        let num = quantity % 2;
        let updates = {
          id: singleComposterId,
          quantity: num,
        };
        try {
          let res = await theme.cart.changeProperties(updates);
          if (res) {
            theme.cart
              .addCart({
                items: [{ id: twinComposterId, quantity: Math.floor(quantity / 2) }],
              })
              .then(() => {
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {},
                  }),
                );
              });
          } else {
            // failed to transform single-composter to twin-composter
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    /**
     *  Unify cart discount format with `/cart.js` result
     * @param {*} cart_level_discount_applications
     * @returns
     */
    formatChangeReturnDiscount: (cart_level_discount_applications) => {
      let mergeDiscount = cart_level_discount_applications.reduce(
        (res, item) => {
          let mergeItem = item;
          if (mergeItem.discount_application) {
            // update cart item number
            mergeItem = item.discount_application;

            //return item.discount_application ;
          }
          if (!res[item.title]) {
            res[item.title] = mergeItem;
          } else {
            res[item.title].total_allocated_amount =
              res[item.title].total_allocated_amount +
              mergeItem.total_allocated_amount;
          }
          res[item.title].formattedAmount = `$${(
            res[item.title].total_allocated_amount / 100
          ).toFixed(2)}`;
          return res;
        },
        {},
      );
      return Object.values(mergeDiscount);
    },
    intersection: function (arr1, arr2) {
      const result = [];
      for (let i = 0; i < arr1.length; i++) {
        if (arr2.includes(arr1[i])) {
          result.push(arr1[i]);
        }
      }
      return result;
    },
    // judge planters/garden beds is in cart, but seedlings is not
    judgePlanters: function (items) {
      return;
      if (theme.pathMarketPrefix()) return;
      if (!items.length) return $(".cart-errors-container").html(``);
      let handles = items.map((item) => item.handle);
      let isGardenBeds =
        items.filter(
          (item) =>
            item.product_type.toLowerCase() == "garden beds" &&
            item.handle != "17-tall-vego-garden-2-ft-extension-kit" &&
            item.handle !=
              "11-tall-2-extension-kit-for-10-in-1-raised-garden-bed" &&
            item.handle !=
              "32-tall-2-extension-kit-for-10-in-1-raised-garden-bed" &&
            item.handle !=
              "vego-extension-kit-41-for-32-modern-raised-garden-beds" &&
            item.handle !=
              "vego-extension-kit-41-for-17-modern-raised-garden-beds",
        ).length > 0;
      let seedlings = [
        "cherokee-purple-tomato-seedlings",
        "sweet-100-tomato-seedlings",
        "jalapeno-tam-pepper-seedlings",
        "jewel-mix-nasturtium-seedlings",
        "celebrity-plus-tomato-seedlings",
        "brandywine-pink-tomato-seedlings",
        "patio-snacker-cucumber-seedlings",
        "french-thyme-seedlings",
        "sungold-tomato-seedlings",
        "quick-snack-cucumber-seedlings",
        "better-boy-tomato-seedlings",
        "mountain-magic-tomato-seedlings",
        "big-bertha-bell-pepper-seedlings",
        "sweet-banana-pepper-seedlings",
        "super-chili-pepper-seedlings",
        "black-beauty-eggplant-seedlings",
        "asian-delite-eggplant-seedlings",
        "ambrosia-cantaloupe-seedlings",
        "yellow-crookneck-squash-seedlings",
        "endurance-zucchini-squash-seedlings",
        "burpless-cucumber-seedlings",
        "arp-rosemary-seedlings",
        "italian-flat-leaf-parsley-seedlings",
        "greek-oregano-seedlings",
        "happy-yellow-french-marigold-seedlings",
        "clemson-spineless-okra-seedlings",
        "chive-seedlings",
        "spearmint-seedlings",
        "east-indian-lemongrass-seedlings",
        "red-velvet-tomato-seedlings",
        "cocoa-tomato-seedlings",
        "sweet-fresh-bites-orange-pepper-seedlings",
        "hot-tamale-pepper-seedlings",
        "italian-large-leaf-basil-seedlings",
        "crimson-sweet-watermelon-seedlings",
      ];
      let planters = [
        "self-watering-rolling-tomato-planter-pot-with-trellis",
        "self-watering-herb-planter-box-with-trellis",
        "self-watering-mini-planter-pot-with-trellis",
      ];
      if (
        (this.intersection(handles, planters).length || isGardenBeds) &&
        !this.intersection(handles, seedlings).length
      ) {
        $(".cart-errors-container").html(
          `Don't forget to add your free seedlings into cart.`,
        );
      } else {
        $(".cart-errors-container").html(``);
      }
    },
    judgeBundle: function (items) {
      if (theme.pathMarketPrefix()) return;
      if (!items.length) return $(".cart-errors-container").html(``);
      let handles = items.map((item) => item.handle);

      let bundleProudcts = document
        .querySelector(".classic_add_ons_planters_data")
        .innerText.split(",");
      if (this.intersection(handles, bundleProudcts).length) {
        $(".cart-errors-container").html(
          `Bundle & Save: Click <a href="/collections/bundles">here</a> for unbeatable discounts! `,
        );
      } else {
        $(".cart-errors-container").html(``);
      }
    },
    _updateCart: async function (params) {
      let response = await fetch(params.url, {
        method: "POST",
        body: params.data,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      response = response.json();
      response.then((cart) => {
        // console.log(cart,'cart');
      });

      return response;
    },
    updateAttributes: function (attributes) {
      let cart;
      $.ajax({
        url: "/cart/update.js",
        method: "POST",
        dataType: "json",
        data: JSON.stringify({
          attributes: attributes,
        }),
        async: false,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        success: function (res) {
          cart = res;
          // console.log(cart);
        },
      });
      return cart;
    },
    setbundleQuantity: function (cart) {
      cart.attributes.bundleQuantity = "";
      let bundleArr = cart.items.filter((item) => {
        if (item?.properties?.fields) {
          return item?.properties?.fields?.filter(
            (field) => field.key == "__is_bundleProduct",
          );
        } else {
          return item?.properties?.__is_bundleProduct;
        }
      });
      bundleArr.map((item, index) => {
        if (index < bundleArr.length - 1) {
          cart.attributes.bundleQuantity += `handle: ${item.handle}-- price: ${item.price}-- variantID: ${item.id}-- quantity: ${item.quantity}__`;
        } else {
          cart.attributes.bundleQuantity += ` handle: ${item.handle}-- price: ${item.price}-- variantID: ${item.id}-- quantity: ${item.quantity}`;
        }
      });
      return this.updateAttributes(cart.attributes);
    },

    /**
     * automatically add herb planter to cart when quantity of herb planter is not match with foodcuble quantity
     * @param {*} items
     */
    judgeAutoAddHerbPlanter: (items) => {
      let herbPlantersVariant = [
        `40251254669347`,
        `40251254702115`,
        `40251254734883`,
      ];
      let varaintId = `40251254702115`;
      let new_quantity = items.reduce((res, item) => {
        if (
          [
            `foodcube-the-next-generation-of-raised-garden-self-watering-elevated`,
            `foodcube-slim`,
            `foodcube`,
            `foodcube-slim-the-next-generation-of-raised-garden-self-watering-elevated`,
          ].includes(item.handle)
        ) {
          res += item.quantity;
        } else if (herbPlantersVariant.includes(`${item.variant_id}`)) {
          res -= item.quantity;
        }
        return res;
      }, 0);
      if (new_quantity > 0) {
        theme.cart
          .addCart({
            items: [{ id: varaintId, quantity: new_quantity }],
          })
          .then(() => {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  addToCartBtn: null,
                },
              }),
            );
          });
      }
    },
    /**
     *
     * @returns true: not bad request, false: bad request
     */
    judgeBadRequestFn: () => {
      let br = (localStorage.getItem("badRequest") ?? "0:0").split(":");
      let now_time = new Date().getTime();
      let requestCount = parseInt(br[0]);
      let gap_time = 2000;
      let lastRequestTime = parseInt(br[1]);
      // console.log(now_time, lastRequestTime,now_time-lastRequestTime)
      if (requestCount > 5 && now_time - lastRequestTime < gap_time) {
        // over request count and gap time is short, cancel auto add gift to cart
        document
          .querySelector(".free-gift-progress-pic")
          ?.classList?.add?.("disable-auto-add-cart");
        localStorage.setItem("disable-auto-add-cart", ts2shortDateFormat());
        localStorage.setItem("badRequest", "0:0"); // reset request count
        // console.log(`stop on `, localStorage.getItem('badRequest'))
        return false;
      } else if (now_time - lastRequestTime < gap_time) {
        localStorage.setItem("badRequest", requestCount + 1 + ":" + now_time); // increment request count
        // console.log(`go on `, localStorage.getItem('badRequest'))
        return true;
      } else {
        localStorage.setItem("badRequest", "1:" + now_time); // reset request count
        // console.log('reset - -->', localStorage.getItem('badRequest'))
        return true;
      }
    },
    /**
     * calc update gift number
     * @param {*} num_type  number of less than gifts
     * @param {*} res_map
     * @param {*} key       normal, premium, deluxe
     * @returns
     */
    getUpdateParam: (num_type, res_map, key) => {
      num_type = 0 - num_type;
      let gift_map = res_map[key].gift_map;
      let _num = res_map[key].ghs;
      let _res = Object.keys(gift_map).reduce((res, key) => {
        if (_num > 0) {
          if (gift_map[key] <= _num) {
            res[key] = gift_map[key];
            _num -= gift_map[key];
          } else {
            res[key] = _num;
            _num = 0;
          }
        } else {
          res[key] = 0;
        }
        return res;
      }, {});
      return _res;
    },
    /**
     * ## Auto Add Gh gift for gh products
     * @param {*} items  cart items
     */
    autoAddtoCartGHGift: async function (items) {
      try {
        let gh_gift = {
          normal: {
            gift_v_id: "41544284373027",
            gift_handle: "greenhouse-vent-gift-box",
            ghs: [
              "vego-garden-junior-victorian-greenhouse-6-5-ft",
              "vego-garden-junior-victoria-greenhouse-8-0-ft",
            ],
          },
          premium: {
            gift_v_id: "41501523836963",
            gift_handle: "greenhouse-premium-gift-box",
            ghs: [
              // "vego-grand-victoria-greenhouse-12-5ft-wide-4-tier-grow-light-garden-pro-with-bistro-set",
              "vego-garden-victorian-greenhouse-85-ft",
              "vego-garden-pacific-greenhouse",
            ],
          },
          deluxe: {
            gift_v_id: "41501564862499",
            gift_handle: "greenhouse-deluxe-gift-box",
            ghs: [
              "vego-garden-pacific-greenhouse-10-5-ft",
              "vego-garden-pacific-greenhouse-12-5-ft",
              "vego-garden-victorian-greenhouse-10-5-ft",
              "vego-garden-victorian-greenhouse-12-5-ft",
            ],
          },
        };
        if (items.length) {
          let res_map = items.reduce(
            (res, item) => {
              // premium
              if (gh_gift.premium.ghs.includes(item.handle))
                res.premium.ghs += item.quantity;
              else if (item.handle == gh_gift.premium.gift_handle) {
                res.premium.gift += item.quantity;
                res.premium.gift_map[item.key] = item.quantity;
              }
              // deluxe
              if (gh_gift.deluxe.ghs.includes(item.handle))
                res.deluxe.ghs += item.quantity;
              else if (item.handle == gh_gift.deluxe.gift_handle) {
                res.deluxe.gift += item.quantity;
                res.deluxe.gift_map[item.key] = item.quantity;
              }
              // normal
              if (gh_gift.normal.ghs.includes(item.handle))
                res.normal.ghs += item.quantity;
              else if (item.handle == gh_gift.normal.gift_handle) {
                res.normal.gift += item.quantity;
                res.normal.gift_map[item.key] = item.quantity;
              }

              return res;
            },
            {
              normal: {
                ghs: 0,
                gift: 0,
                gift_map: {
                  //[gift_key]:[gift_quantity]
                },
              },
              deluxe: { ghs: 0, gift: 0, gift_map: {} },
              premium: { ghs: 0, gift: 0, gift_map: {} },
            },
          );

          let num_deluxe = res_map.deluxe.ghs - res_map.deluxe.gift,
            num_normal = res_map.normal.ghs - res_map.normal.gift,
            num_premium = res_map.premium.ghs - res_map.premium.gift;
          let add_params = [],
            update_params = {};

          // normal
          if (num_normal > 0)
            add_params.push({
              id: gh_gift.normal.gift_v_id,
              properties: { __original_price: "129.95" },
              quantity: num_normal,
            });
          else if (num_normal < 0) {
            let _res = this.getUpdateParam(num_normal, res_map, "normal");
            update_params = {
              ..._res,
              ...update_params,
            };
            //or update_params[gh_gift.normal.gift_v_id] = res_map.normal.ghs; // can not update when there is two line items for one variant
          }

          // deluxe
          if (num_deluxe > 0)
            add_params.push({
              id: gh_gift.deluxe.gift_v_id,
              properties: { __original_price: "409.95" },
              quantity: num_deluxe,
            });
          else if (num_deluxe < 0) {
            let _res = this.getUpdateParam(num_normal, res_map, "deluxe");
            update_params = {
              ..._res,
              ...update_params,
            };
          }

          // premium
          if (num_premium > 0)
            add_params.push({
              id: gh_gift.premium.gift_v_id,
              properties: { __original_price: "229.95" },
              quantity: num_premium,
            });
          else if (num_premium < 0) {
            let _res = this.getUpdateParam(num_normal, res_map, "premium");
            update_params = {
              ..._res,
              ...update_params,
            };
          }

          let request_arr = [];
          if (add_params.length > 0)
            request_arr.push(theme.cart.addCart({ items: add_params }));
          else if (Object.keys(update_params).length > 0)
            request_arr.push(theme.cart.updateItem(update_params));
          if (request_arr.length) {
            await Promise.all(request_arr);
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  addToCartBtn: null,
                },
              }),
            );
            return true;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
      return false;
    },
    autoAddtoCartCoverGift: async function (items) {
      try {
        let cover_gift = {
          gift_v_id: 42456647270435,
          hosereels: [
            "40313682395171", //VWRHRS12130BL
            "40313706414115", //VWRHRS12130GR
            "40313706381347", //VWRHRS12130WT
            "40313682296867", //VWRHRS58100BL
            "40313682591779", //VWRHRS58100GR
            "40313682559011", //VWRHRS58100WT
          ],
          hosereels_2pack: [
            "40837276893219", //VWRHRS12130BL
            "40837276991523", //VWRHRS12130GR
            "40837277089827", //VWRHRS12130WT

            "40837258477603", //VWRHRS58100BL
            "40837258575907", //VWRHRS58100GR
            "40837258674211", //VWRHRS58100WT
          ],
        };
        if (items.length) {
          let res_map = items.reduce(
            (res, item) => {
              if (cover_gift.hosereels.includes(`${item.variant_id}`))
                res.gift += item.quantity;
              else if (
                cover_gift.hosereels_2pack.includes(`${item.variant_id}`)
              ) {
                res.gift += 2 * item.quantity;
              } else if (item.variant_id == cover_gift.gift_v_id) {
                res.gift -= item.quantity;
                res.gift_exist_num += item.quantity;
              }
              return res;
            },
            {
              gift: 0,
              gift_exist_num:0
            },
          );

          let git_num = res_map.gift;
        let add_params = [],
          update_params = {};
          if (git_num > 0)
            add_params.push({
              id: cover_gift.gift_v_id,
              properties: { __original_price: "29.95" },
              quantity: git_num,
            });
          else if (git_num < 0) {
            //-// let _res = this.getUpdateParam(git_num, res_map);
            update_params = {
              //..._res,
              [cover_gift.gift_v_id]: 0//res_map.gift_exist_num + git_num,
            };
          }
          //console.log(update_params,);

          let request_arr = [];
          if (add_params.length > 0)
            request_arr.push(theme.cart.addCart({ items: add_params }));
          else if (Object.keys(update_params).length > 0)
            request_arr.push(theme.cart.updateItem(update_params));
          if (request_arr.length) {
            await Promise.all(request_arr);
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  addToCartBtn: null,
                },
              }),
            );
            return true;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
      return false;
    },

    //Free GIFT FOR ORDER VALUE
    judgeAutoAddGiftBox: async (items, total_exclude_gift_card) => {
      // console.log('total_exclude_gift_card--->>',total_exclude_gift_card,items)
      return new Promise((resolve, reject) => {
        let exist = null;
        if (theme.isCA?.()) return resolve(false);
        if (
          total_exclude_gift_card >=
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1
        ) {
          exist = items.find(
            (item) =>
              item.variant_id ==
              theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level1,
          ); // exist and exist discount applied
          if (!exist && theme.CartDrawer.prototype.judgeBadRequestFn()) {
            theme.cart
              .addCart({
                items: [
                  {
                    id: theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level1,
                    quantity: 1,
                  },
                ],
              })
              .then(() => {
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      addToCartBtn: null,
                    },
                  }),
                );
                resolve(true);
              });
          } else {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      });
    },
    judgeAutoAddGiftBoxTwoLevel: async (items, total_exclude_gift_card) => {
      return new Promise((resolve, reject) => {
        let exist = null;
        if (theme.isCA?.()) return resolve(true);
        let variantId = ``;
        if (
          total_exclude_gift_card >=
            theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 &&
          total_exclude_gift_card <
            theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2
        ) {
          variantId = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level1;
        } else if (
          total_exclude_gift_card >=
          theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level2
        ) {
          variantId = theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level2;
        }
        if (variantId) {
          exist = items.find((item) => item.variant_id == variantId); // exist and exist discount applied
          if (!exist) {
            theme.cart
              .addCart({
                items: [{ id: variantId, quantity: 1 }],
              })
              .then(() => {
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      addToCartBtn: null,
                    },
                  }),
                );
                resolve(true);
              });
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
      // console.log('total_exclude_gift_card' + total_exclude_gift_card)

      //  else if (total_exclude_gift_card >= 350) {
      //   exist = items.find(item => item.variant_id == 39964453503011)
      //   if (!exist) theme.cart.addCart([
      //     `id=39964453503011`, `quantity=1`
      //   ].join('&')).then(() => {
      //     document.dispatchEvent(
      //       new CustomEvent('ajaxProduct:added', {
      //         detail: {
      //           addToCartBtn: null,
      //         },
      //       })
      //     )
      //   })
      // }
    },

    /**
     * automatically add product to cart by globalobject config
     * @param {*} items
     */
    judgeAutoAddLightForBed: (items) => {
      return new Promise((resolve) => {
        let configEl = document.querySelector(".auto-add-to-cart-config");
        if (configEl) {
          let varaintId = configEl.getAttribute("data-free-variants-frees");
          let beds = configEl
            .getAttribute("data-free-variants-products")
            .split(",");
          let existTargetProducts = items.find((item) =>
            beds.includes(`${item.product_id}`),
          );
          let existLightProducts = items.find(
            (item) => `${item.variant_id}` == varaintId,
          );
          if (!existLightProducts && existTargetProducts) {
            theme.cart
              .addCart({
                items: [{ id: varaintId, quantity: 1 }],
              })
              .then(() => {
                resolve(true);
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      addToCartBtn: null,
                    },
                  }),
                );
              })
              .catch(() => {
                resolve(true);
              });
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    },
    judgeAutoAddLightsForBedNum: async function (items) {
      // Reuse an in-flight sync so repeated cart renders cannot add gifts twice.
      if (this.autoGiftSyncPromise) return this.autoGiftSyncPromise;

      const configs = Array.from(
        document.querySelectorAll(".auto-add-to-cart-config"),
      ).flatMap((configEl) => {
        try {
          // Support both data attributes and the JSON rendered by Liquid.
          let config = JSON.parse(
            configEl.getAttribute("data-free-variants-config") ||
              configEl.textContent.trim() ||
              "null",
          );
          if (typeof config === "string") config = JSON.parse(config);
          return (Array.isArray(config) ? config : [config])
            .filter((item) => item && item.free)
            .map((item) => ({
              ...item,
              products: Array.isArray(item.products) ? item.products : item.buys,
            }))
            .filter((item) => Array.isArray(item.products));
        } catch (error) {
          console.warn("Invalid auto-add-to-cart config", error);
          return [];
        }
      });

      // Merge rules for the same gift without counting a product twice.
      const giftProducts = new Map();
      configs.forEach(({ free, products }) => {
        const variantId = String(free);
        if (!giftProducts.has(variantId)) {
          giftProducts.set(variantId, new Set());
        }
        products.forEach((id) => giftProducts.get(variantId).add(String(id)));
      });

      const additions = [];
      const updates = {};
      giftProducts.forEach((productIds, variantId) => {
        // One purchased unit earns one gift, including products sold as packs.
        // Gifts themselves must not qualify for another gift.
        const targetQuantity = items.reduce((quantity, item) => {
          return productIds.has(String(item.product_id)) &&
            !giftProducts.has(String(item.variant_id))
            ? quantity + item.quantity
            : quantity;
        }, 0);
        const giftLines = items.filter(
          (item) => String(item.variant_id) === variantId,
        );
        const giftQuantity = giftLines.reduce(
          (quantity, item) => quantity + item.quantity,
          0,
        );

        if (targetQuantity > giftQuantity) {
          additions.push({
            id: variantId,
            quantity: targetQuantity - giftQuantity,
          });
        } else if (targetQuantity < giftQuantity) {
          // A variant may have multiple lines (properties or discounts differ).
          // Update by line key to retain exactly the required total quantity.
          let remaining = targetQuantity;
          giftLines.forEach((item) => {
            const quantity = Math.min(item.quantity, remaining);
            remaining -= quantity;
            if (quantity !== item.quantity) updates[item.key] = quantity;
          });
        }
      });

      if (!additions.length && !Object.keys(updates).length) return false;

      this.autoGiftSyncPromise = (async () => {
        let changed = false;
        try {
          // Serialize writes so one request cannot overwrite another's cart.
          if (Object.keys(updates).length) {
            const result = await theme.cart.updateItem(updates);
            if (result?.status >= 400) throw new Error(result.description);
            changed = true;
          }
          if (additions.length) {
            const result = await theme.cart.addCart({ items: additions });
            if (result?.status >= 400) throw new Error(result.description);
            changed = true;
          }
        } catch (error) {
          console.error("Unable to sync cart gifts", error);
        } finally {
          this.autoGiftSyncPromise = null;
          // Also refresh after a partial success if a later request failed.
          if (changed) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: { addToCartBtn: null },
              }),
            );
          }
        }
        return changed;
      })();
      return this.autoGiftSyncPromise;
    },
    isOpen: () => {
      return document
        .querySelector("#CartDrawer")
        .classList.contains("drawer--is-open");
    },

    openCart() {
      let cart_drawer_el = document.querySelector("cart-drawer");
      theme.utils.prepareTransition(cart_drawer_el, () => {
        cart_drawer_el.classList.add(`drawer--is-open`);
      });
      document.documentElement.classList.add("js-drawer-open");
    },
    /**
     * Handle Shipping Fee
     */
    shippingFeeFn(total, cartTotal) {
      let freeShippingEl = document.querySelector(
        ".vego-prompt-banner  div.free-shipping",
      );
      // let bannerEl = document.querySelector('.vego-prompt-banner')
      // if (!document.querySelector('.free-gift-box')) return
      if (!freeShippingEl) return;
      total = total / 100;
      if (cartTotal > 9900) {
        freeShippingEl.style.display = "none";
        // bannerEl.style.display = 'none'
        // document.querySelector('.free-gift-box').style.display = 'block';
        theme.setCartHeightOfMainContent();
        return;
      }
      if (total >= 99) {
        freeShippingEl.style.display = "none";
        // bannerEl.style.display = 'none'
        // document.querySelector('.free-gift-box').style.display = 'block';
        theme.setCartHeightOfMainContent();
      } else {
        //        document.querySelector('.free-gift-box').style.display = 'none';
        theme.setCartHeightOfMainContent();
        freeShippingEl.innerHTML = `<shipping-fee-progress class="sf-container" data-total="${(
          99 - total
        ).toFixed(2)}">
          <div class="sf-text">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M3.46216 15.9773C3.46216 16.5058 3.67208 17.0126 4.04574 17.3862C4.4194 17.7599 4.92619 17.9698 5.45463 17.9698C5.98306 17.9698 6.48985 17.7599 6.86351 17.3862C7.23717 17.0126 7.44709 16.5058 7.44709 15.9773C7.44709 15.4489 7.23717 14.9421 6.86351 14.5684C6.48985 14.1948 5.98306 13.9849 5.45463 13.9849C4.92619 13.9849 4.4194 14.1948 4.04574 14.5684C3.67208 14.9421 3.46216 15.4489 3.46216 15.9773Z"
                      fill="#3A5B39" />
                  <path
                      d="M17.6723 7.29918L13.6921 5.07569V4.30738C13.6921 3.05497 12.6674 2.03027 11.415 2.03027H4.03162C2.77921 2.03027 1.75452 3.05497 1.75452 4.30738V13.4158C1.75452 14.0605 2.0261 14.6449 2.46047 15.0602C2.85263 13.7786 4.04481 12.8465 5.45482 12.8465C7.08805 12.8465 8.42898 14.0971 8.57281 15.6929H11.428C11.5718 14.0971 12.9128 12.8465 14.546 12.8465C15.956 12.8465 17.1482 13.7786 17.5403 15.0602C17.9747 14.6449 18.2463 14.0605 18.2463 13.4158V8.43295C18.3002 7.98736 18.0868 7.5307 17.6723 7.29918ZM16.5385 10.0001C16.5385 10.3132 16.2823 10.5694 15.9692 10.5694H13.6921C13.379 10.5694 13.1228 10.3132 13.1228 10.0001V7.72304C13.1228 7.40994 13.379 7.15376 13.6921 7.15376C14.0052 7.15376 14.2614 7.40994 14.2614 7.72304V9.43087H15.9692C16.2823 9.43087 16.5385 9.68704 16.5385 10.0001Z"
                      fill="#3A5B39" />
                  <path
                      d="M12.5533 15.9773C12.5533 16.5058 12.7633 17.0126 13.1369 17.3862C13.5106 17.7599 14.0174 17.9698 14.5458 17.9698C15.0742 17.9698 15.581 17.7599 15.9547 17.3862C16.3284 17.0126 16.5383 16.5058 16.5383 15.9773C16.5383 15.4489 16.3284 14.9421 15.9547 14.5684C15.581 14.1948 15.0742 13.9849 14.5458 13.9849C14.0174 13.9849 13.5106 14.1948 13.1369 14.5684C12.7633 14.9421 12.5533 15.4489 12.5533 15.9773Z"
                      fill="#3A5B39" />
              </svg>
              <span>
                  You're only <span>$${(99 - total).toFixed(
                    2,
                  )}</span> away from <span>free shipping</span>!
              </span>
          </div>
          <div class="p-progress-container ">
              <div class="p-c-progress">
                  <div class="p-progress "></div>
              </div>
              <span>
                  Only $${(99 - total).toFixed(2)}
              </span>
          </div>
      </shipping-fee-progress>`;
        // Notes: You're only $${(99 - total).toFixed(2)} away from free shipping!
        freeShippingEl.style.display = "block";
        // bannerEl.style.display = 'block'
        //  el.style.display = 'block'
      }
    },
    getGiftData: async () => {
      let gift_data_url = `https://${location.host}/products/vego-garden-6-in-1-modular-raised-garden-bed-kit?view=gift`;
      let gift_data_res = await fetch(gift_data_url);
      gift_data_res = await gift_data_res.text();
      let [v_id, handle, order_amount] = gift_data_res.trim().split("/");
      theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId.level1 =
        `${v_id}`.trim();
      theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelOrder.level1 =
        parseInt(order_amount);
      theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.handle = handle;
    },
    getAllAppliedCodes() {
      return Array.from(
        this.appliedDiscountCode.querySelectorAll(
          ".applied-discount-code-value",
        ),
      ).map((item) => item.innerText.trim());
    },
    appendDiscountHtml_APP(codes) {
      this.appliedDiscountCode.innerHTML = codes
        .map((code) => {
          return `<span class="applied-discount-code-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
        <path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path>
      </svg>
      <span class="applied-discount-code-value">${code}</span>
      <button class="clear-discount-btn">×</button>
    </span>`;
        })
        .join("");
    },
    //  ===== DISCOUNT APP CODE INPUT BEGIN =====
    initDiscountInput_APP() {
      // clear btn element
      this.clearBtn = document.querySelector("#clear-discount-btn");
      // apply btn element
      this.applyBtn = document.querySelector("#apply-discount-btn");
      // discount code error element
      this.discountCodeError = document.querySelector("#discount-code-error");
      // discount code element
      this.appliedDiscountCode = document.querySelector(
        "#applied-discount-code",
      );

      this.applyOperateArea = document.querySelector(".apply-operate-area");

      this.discountCodeInput = document.querySelector("#discount-code-input");
      // cart total element function
      this.cartTotalEl = function (htmlStr) {
        let el = document.querySelector(".ajaxcart__price_total");
        if (el && htmlStr) el.innerHTML = htmlStr;
      };
      this.totalCartSelector = document.querySelector(".totals__total-value"); // Total Cart Selector to update the total amount.
      this.checkoutContainer = document.createElement("div");
      document.body.appendChild(this.checkoutContainer);
      this.initEvent_APP();
    },
    async initEvent_APP() {
      this.applyBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        if (!this.discountCodeInput.value) return;
        this.applyDiscount_APP(this.discountCodeInput.value);
      });
      this.appliedDiscountCode.addEventListener("click", (e) => {
        e.preventDefault();
        if (e.target.classList.contains("clear-discount-btn")) {
          let current_code = e.target
            .closest(".applied-discount-code-wrapper")
            .querySelector(".applied-discount-code-value")
            .innerText.trim();
          let avaliable_codes = this.getAllAppliedCodes().filter(
            (item) => item != current_code,
          );
          this.applyDiscount_APP(avaliable_codes.join(","), true);
        }
      });
    },
    cartData_APP: null,

    applyingFn_APP(loading = true) {
      if (loading) {
        this.applyBtn.innerHTML = "Applying <div class='loader'></div>";
        this.applyBtn.style.pointerEvents = "none";
      } else {
        this.applyBtn.innerHTML = "Apply";
        this.applyBtn.style.pointerEvents = "all";
      }
    },

    /**
     * ##  Apply discount to cart
     *
     *  Update Discount Steps below:
     * 1. 应用/取消折扣码，变更总价
     * 2. 应用折扣码后，变更购物车中商品，变更总价
     * 3. 变更商品后，去除折扣码商品，变更总价
     * @param {*} code
     */
    async applyDiscount_APP(code, is_remove) {
      this.applyingFn_APP();
      try {
        let data = await theme.cart._updateCart({
          url: theme.routes.cartUpdate,
          data: JSON.stringify({
            discount: is_remove
              ? code
              : [...this.getAllAppliedCodes(), code].join(","),
          }),
        });
        if (code) {
          if (
            data.discount_codes.find(
              (item) => code.includes(item.code) && item.applicable,
            )
          ) {
            this.updateDiscountHtml_APP(
              data.discount_codes
                .filter((item) => item.applicable)
                .map((item) => item.code),
              data,
            );
            this.buildCart(data, false, null);
          } else {
            // this.discountCodeValue.innerHTML = "";
            this.discountCodeError.innerHTML = `Coupon code '${code}' could not be applied.`;
          }
        } else {
          this.buildCart(data, false, null);
          // this.discountCodeValue.innerHTML = "";
          this.discountCodeError.innerHTML = "";
          this.discountCodeInput.value = "";
          this.applyOperateArea.style.display = "flex";
          this.appliedDiscountCode.style.display = "none";
          this.appliedDiscountCode.innerHTML = "";
          // this.clearLocalStorage(false);
        }
        this.applyingFn_APP(false);
        // How to display discount info that applied to line items?
      } catch (error) {
        console.log(error);
        this.applyingFn_APP(false);
      }
    },
    updateDiscountHtml_APP(code, data) {
      if (!this.appliedDiscountCode) return;
      this.appliedDiscountCode.style.display = "flex";
      this.discountCodeError.innerHTML = "";
      this.appendDiscountHtml_APP(code);
      this.totalCartSelector.innerHTML = ``;
      this.discountCodeInput.value = "";
    },
    handleFreeCardDataInCart:(cartItems)=>{
      if(!window.VegoPromotions)return;
      if (!window._VegoPromotions)window._VegoPromotions = window.VegoPromotions.filter(
        (item) => item.status == "active",
      )[0].productRules.reduce((res, item) => {
        let product_id = item.product_id.split("/").pop();
        res[product_id] = item;
        return res;
      }, {});
       cartItems.forEach(item=>{
        let rule_target = window._VegoPromotions[item.productId];
        if (rule_target) {
          item.freeCardInfo = {
            ...rule_target,
            info: `Get a FREE $${rule_target.reward_value} Gift Card with Purchase`,
        };
        }
       })
    },
    //DISCOUNT APP CODE INPUT END
    buildCart: async function (cart, openDrawer, returnFocusEl) {
      theme.disableViewScaled();
      // Free GIFT FOR ORDER VALUE
      // if (window.route_prefix == "/") await this.getGiftData(); //
      if (!window.handleMatchAddonsAndBeds) window.initAddonsWidget?.(window);
      this.loading(true);
      this.emptyCart();
      this.cart = cart;

      // DISCOUNT APP CODE INPUT
      let applied_discount_code = cart.discount_codes
        .filter((item) => item.applicable)
        .map((item) => item.code);
      if (applied_discount_code.length) {
        this.updateDiscountHtml_APP(applied_discount_code, cart);
      } else {
        let discount_code_el = document.querySelector("#applied-discount-code");
        if (discount_code_el) discount_code_el.style.display = "none";
      }

      if (openDrawer) {
        this.openCart();
        theme.resizeCart();
      }
      if (document.querySelector("#CartBubble"))
        document.querySelector("#CartBubble").innerHTML = cart.item_count;
      //if (!this.isOpen() && !openDrawer) return;
      // 启用的活动类型
      const activityType = document.querySelector("#CartDrawer").dataset.type;
      const that = this;
      // cart = this.setbundleQuantity(cart)
      if (cart.item_count === 0) {
        //hide promotion

        $(".shipping-information-box").hide();
        $(".cart-apply-discount").hide();
        $(".cart-area-pro").hide();
        document.querySelector(
          ".vego-prompt-banner  div.free-shipping",
        ).style.display = "none"; // hide free shipping information
        //show empty
        let href = location.pathname.startsWith("/en-ca") ? "/en-ca" : "";
        if (theme.isAu()) href = "/en-au";
        $(CartAreaConst.empty).show();
        $(".drawer__scrollable.vego-flex1").addClass("cart-empty-container");
        $(CartAreaConst.empty)
          .html(`<div class="appear-animation appear-content-box appear-delay-3">
                    ${theme.isCa() || theme.isAu() ? `` : ""}
                   <p>${theme.strings.cartEmpty}</p>
                   <p class="cart-empty-slogan" >Give yourself room to grow.</p>
                  <div>
                    ${
                      !document
                        .querySelector(".cart-empty-customize")
                        .innerHTML.trim()
                        ? `<div class="cart-category cart-category-null">
                    <a class="go-shoping btn btn-white" href="${href}/collections/garden-beds" data-uw-rm-brl="false">Shop Raised Beds</a>
                    ${
                      location.pathname.startsWith("/en-ca")
                        ? ""
                        : ` <a class="go-shoping btn btn-white" href="${href}/collections/advanced-beds" data-uw-rm-brl="false"><span>Shop </span>Advanced Beds</a>
                    <a class="go-shoping btn btn-white" href="${href}/collections/add-ons" data-uw-rm-brl="false"><span>Shop </span>Add-Ons</a>
                    <a class="go-shoping btn btn-white" href="${href}/collections/accessories" data-uw-rm-brl="false"><span>Shop </span>Accessories</a>
                    <a class="go-shoping btn btn-white" href="${href}/collections/essentials" data-uw-rm-brl="false"><span>Shop </span>Essentials</a>`
                    }
                  </div>`
                        : document.querySelector(".cart-empty-customize")
                            .innerHTML
                    }
                  </div>
          </div>`);
        this.judgePlanters([]);
        document.querySelector(
          ".cart-container > .vego-flex1",
        ).style.borderBottom = "none";
        document.querySelector(
          ".cart-container > .vego-flex1",
        ).style.borderRight = "none";
        this.updateCartCount(0);
        document
          .querySelector(".free-gift-progress")
          ?.setAttribute("data-cart-total", `0`);
        that.cartPart2(cart, openDrawer, returnFocusEl);
        that.addScrollEvent();
        return;
        /**
         * ## Campaign 2: 购物车顶部显示满足条件的商品CTA
         */
      } else {
        $(".drawer__scrollable.vego-flex1").removeClass("cart-empty-container");
        this.transformSingleToComposterTwin(cart.items);
        window.transformProductToBundle?.(cart.items);
        // await this.judgeAutoAddLightForBed(cart.items)
        //Free Seedling Tray 8-Pack with Select Grow Light Gardens
        // Free $59 Seed Kit With Select Garden Beds - v2
        // Gift changes trigger a fresh cart render; do not render or update
        // preorder properties using the previous cart quantities and line keys.
        this.judgeAutoAddLightsForBedNum(cart.items);
        theme.cart.updatePreOrder(cart.items);
        var items = [],
          numQty = 0,
          item = {},
          data = {},
          itemsMap = {},
          totalPriceWithoutGiftBox = 0,
          totalFeeIncludeSoildRoute = 0,
          totalNumIncludeSoildRoute = 0;
        let variantIds = [];
        var animation_row = 2;
        //var shippingFee = 0

        // this.judgePlanters(cart.items);
        // this.judgeBundle(cart.items)
        // let is_first_gift_box  = true
        for (var product of cart.items) {
          if (product.quantity != 0) {
            var isGiftbox = false;
            itemsMap[product.handle] = product;
            for (var kk in theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId) {
              if (
                theme.CartDrawerConst.FREE_GIFT_BOX_CONFIG.levelId[kk] ==
                product.variant_id
              ) {
                isGiftbox = true;
                break;
              }
            }

            if (!isGiftbox) {
              totalPriceWithoutGiftBox += product.final_line_price;
            }

            var prodImg =
              product.image !== null
                ? product.image.replace(/(\.[^.]*)$/, "_180x$1")
                : (prodImg =
                    "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif");

            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount =
                  product.line_level_discount_allocations[discount].amount;

                product.line_level_discount_allocations[
                  discount
                ].formattedAmount = theme.Currency.formatMoney(
                  amount,
                  theme.settings.moneyFormat,
                );
              }
            }

            animation_row += 2;

            var selling_plan_name = product.selling_plan_allocation
              ? product.selling_plan_allocation.selling_plan.name
              : null;
            numQty += product.quantity;
            let { _is_fullfillDate, _is_fullfillDate_ts, ...properties } =
              product.properties || {};
            //exclude uncessary `custom properties`
            Object.keys(properties).map((key) => {
              if (
                `${key}`.indexOf("undefined") > -1 ||
                key.indexOf(`bundle`) > -1 ||
                (key.indexOf("__original_price") > -1 &&
                  !(properties[key].replace(",", "") > 0))
              ) {
                delete properties[key];
              }
            });
            variantIds.push(product.url.split("=").slice(-1)[0]); // variant id
            product.options_with_values.map((item) => {
              if (item.name == "Bracing Rod Width") {
                item.name = "Bracing Rod";
                if (
                  product.handle !==
                    "11-tall-2-extension-kit-for-10-in-1-raised-garden-bed" &&
                  product.handle !== "17-tall-vego-garden-2-ft-extension-kit" &&
                  product.handle !==
                    "32-tall-2-extension-kit-for-10-in-1-raised-garden-bed"
                ) {
                  item.hide = true;
                }
              }
            });
            item = {
              key: product.key,
              handle: product.handle,
              url: product.url,
              img: prodImg,
              productId: product.product_id,
              animationRow: animation_row,
              name: product.product_title,
              variation: product.variant_title,
              variationLabel: that.itemLabel(product.url),
              properties,
              upgradeDelivery:
                properties._is_upgrade_delivery == "true"
                  ? 150 * product.quantity
                  : 0,
              optionsWithValues: product.options_with_values,
              fulfillDate: _is_fullfillDate,
              fulfillDateTs: _is_fullfillDate_ts,
              itemQty: product.quantity,
              price: theme.Currency.formatMoney(
                product.price * product.quantity,
                theme.settings.moneyFormat,
              ),
              variant_id: product.variant_id,
              compareAtPriceData: theme.pathMarketPrefix()
                ? properties.__original_price
                : (properties?.__original_price ?? 0),
              priceData: product?.price / 100,
              unitPrice: theme.Currency.formatMoney(
                product.unit_price,
                theme.settings.moneyFormat,
              ),
              unitBase: theme.Currency.getBaseUnit(product),
              discountedPrice: theme.Currency.formatMoney(
                // product.price - product.total_discount / product.quantity,
                product.price * product.quantity - product.total_discount,
                theme.settings.moneyFormat,
              ),
              discounts: product.discounts.map((item) => {
                //item.amount = `$${item.amount / 100}`;
                item.amount_formated = theme.Currency.formatMoney(
                  item.amount,
                  theme.settings.moneyFormat,
                );
                return item;
              }),
              // discounts: product.line_level_discount_allocations,
              discountsApplied: product.discounts.length > 0,
              // product.line_level_discount_allocations.length === 0
              //   ? false
              //   : true,
              selling_plan_name: selling_plan_name,
              vendor: product.vendor,
            };
            // =============  To Display compare_at_price of Ca =========================
            if (
              theme.pathMarketPrefix() &&
              100 * properties.__original_price > product.price
            ) {
              item.discountsApplied =
                100 * properties.__original_price > product.price;
              item.compareAtPriceData = properties.__original_price;
              product.original_price = 100 * properties.__original_price;
              item.price = theme.Currency.formatMoney(
                product.original_price * product.quantity,
                theme.settings.moneyFormat,
              );
              item.discountedPrice = theme.Currency.formatMoney(
                // product.price - product.total_discount / product.quantity,
                product.price * product.quantity,
                theme.settings.moneyFormat,
              );
            }
            //console.log(item)
            items.push(item);
          }
        }
        let newItems = items.reduce((res, item) => {
          /**
           * 此方式依赖于套餐商品中包含`bundle`
           */
          let bundleDiscount = (item.discounts ?? []).find(
            (item) =>
              item.discount_application?.title.toLowerCase().indexOf("bundle") >
              -1,
          );
          if (bundleDiscount) {
            let discountTitle = bundleDiscount.discount_application.title;
            if (!res[discountTitle]) {
              res[discountTitle] = [];
            }
            res[discountTitle].push(item);
          } else {
            if (!res["NO_BUNLDE"]) res["NO_BUNLDE"] = [];
            res["NO_BUNLDE"].push(item);
          }
          return res;
        }, {});

        Object.keys(newItems).map((key) => {
          if (newItems[key].length > 1 && key !== `NO_BUNLDE`) {
            newItems[key].map((item, index) => {
              item["is_bundle_not_last_product"] =
                index !== newItems[key].length - 1;
            });
          }
        });

        // sort the newest product as the first one
        const newestProudctVariantId = localStorage.getItem(
          "newestProudctVariantId",
        );
        const arrValues = Object.values(newItems);
        const newestProductIndex = arrValues.findIndex((itemArr) =>
          itemArr.find(
            (cartItem) => cartItem.key.indexOf(newestProudctVariantId) > -1,
          ),
        );
        if (newestProductIndex != -1) {
          //
          newItems = [
            arrValues[newestProductIndex],
            ...arrValues.slice(0, newestProductIndex),
            ...arrValues.slice(newestProductIndex + 1),
          ]
            .flat(2)
            .filter((item) => item);
        } else {
          // last one was removed
          newItems = arrValues.flat(2);
        }
        animation_row += 2;

        // If we have cart discount, add a formattedAmount to the discount object
        var cartAmount = 0;
        if (cart.cart_level_discount_applications.length !== 0) {
          for (var cartDiscount in cart.cart_level_discount_applications) {
            cartAmount =
              cart.cart_level_discount_applications[cartDiscount]
                .total_allocated_amount;

            cart.cart_level_discount_applications[
              cartDiscount
            ].formattedAmount = theme.Currency.formatMoney(
              cartAmount,
              theme.settings.moneyFormat,
            );
          }
        }
        let sfv_el = document.querySelector("shipping-fee-v0");
        let shippingFee = sfv_el?.calcShippingFee?.(cart) ?? 0;

        cart.total_price += shippingFee;
        let totalPrice = theme.Currency.formatMoney(
          cart.total_price,
          theme.settings.moneyFormat,
        );

        // let totalSoilShippingFee = shippingFee
        let totalOriginalPrice = theme.Currency.formatMoney(
          cart.total_price - cart.cart_level_discount_applications,
          theme.settings.moneyFormat,
        );
        data = {
          items: newItems,
          oldItems: items,
          note: cart.note,
          lastAnimationRow: animation_row,
          cartDiscounts: this.formatChangeReturnDiscount(
            cart.cart_level_discount_applications,
          ),
          cartDiscountsApplied:
            cart.cart_level_discount_applications.length === 0 ? false : true,
          totalPrice: totalPrice,
          totalPriceExcludeShippingFee: theme.Currency.formatMoney(
            cart.total_price - shippingFee,
            theme.settings.moneyFormat,
          ),
          // total fee without special amount including total_discount and soil shipping fee
          totalPriceExcludeShippingFee_TotalDiscount:
            theme.Currency.formatMoney(
              cart.total_price + cart.total_discount - shippingFee,
              theme.settings.moneyFormat,
            ),
          totalOriginalPrice:
            totalPrice == totalOriginalPrice ? "" : totalOriginalPrice,
        };
        //=== stuff fee ===: save shipping fee
        // Get gift card total ammount
        let _eGiftTotal = 0;
        let eGiftTotal = items.reduce((eGiftTotal, item) => {
          if (item.url.indexOf(`vego-garden-gift-card`) > -1) {
            eGiftTotal += item.priceData * item.itemQty;
          } else if (item.url.indexOf(`herb-tomato-gift-box`) > -1) {
            // eGiftTotal += item.priceData * item.itemQty
          } else if (item.url.indexOf(`free-gift`) > -1) {
            _eGiftTotal += item.priceData * item.itemQty;
          }
          return eGiftTotal;
        }, 0);
        // this.judgeAutoAddGiftBox(cart.items, (cart.total_price / 100) - eGiftTotal)

        // Free GIFT FOR ORDER VALUE
        // DISABLE AUTO ADD TO CART
        if (window.route_prefix == "/") {
          // let added_cover_gift = await this.autoAddtoCartCoverGift(cart.items);
          // if (added_cover_gift) return;
          // let added_gh_gift = await this.autoAddtoCartGHGift(cart.items);
          // if (added_gh_gift) return; // break build-cart flow after adding gh gift automaically
          // TWO LEVEL GIFT
          // this.judgeAutoAddGiftBoxTwoLevel(cart.items,
          //     cart.items_subtotal_price / 100 - eGiftTotal - _eGiftTotal)
          // if (
          //   !localStorage.getItem("disable-auto-add-cart") &&
          //   localStorage.getItem("disable-auto-add-cart") !=
          //     ts2shortDateFormat()
          // ) {
          //   document
          //     .querySelector(".free-gift-progress-pic")
          //     ?.classList?.remove?.("disable-auto-add-cart");
          //   let is_added_gift = await this.judgeAutoAddGiftBox(
          //     cart.items,
          //     cart.items_subtotal_price / 100 - eGiftTotal - _eGiftTotal
          //   );
          //   if(is_added_gift)return ;// break build-cart flow after adding gift box automaically
          // } else {
          //   document
          //     .querySelector(".free-gift-progress-pic")
          //     ?.classList?.add?.("disable-auto-add-cart");
          //   localStorage.setItem(
          //     "disable-auto-add-cart",
          //     ts2shortDateFormat()
          //   );
          // }
        }

        await that.renderCart();
        //hide empty
        $(CartAreaConst.empty).hide();
        //show promotion
        $(".cart-apply-discount").show();
        $(".cart-area-pro").show();
        /**
         * ## Campaign 1: 根据`price_level_pro`,`product_level_pro`的配置，自动将商品加入购物车.
         */
        // that.totalFillAutoAddtoCart(newItems, cart.total_price / 100)
        this.handleFreeCardDataInCart(data.items);
        const $html = $(
          `<div>${theme.templates["template-cart"].result(data)}</div>`,
        );

        //===========================END:  Dynamiclly show promotation by TOTAL PRICE  ====================================

        that.updateCartCount(numQty);
        that.item_count = numQty;

        Object.keys(CartAreaConst).forEach((key) => {
          const $item = $(`${CartAreaConst[key]}-data`, $html);
          $(CartAreaConst[key]).html(
            key === CartAreaConst.items ? $item.html() : $item,
          );
        });

        sfv_el.renderShippingFee();
        $(".grid-product-variant-title__tip_shipping").tooltip?.();

        /**
         * ## Campaign 2: 购物车顶部显示满足条件的商品CTA
         */
        //this.doCartTip(cart.original_total_price, variantIds)

        $(window).resize(() => {
          // // deprecated
          theme.resizeCart();
        });
        // deprecated
        theme.resizeCart();
        window.handleDevliverDate?.();
        window.handleMatchAddonsAndBeds?.(cart);
        //setupEventListeners()
        this.shippingFeeFn?.(
          totalNumIncludeSoildRoute == cart.item_count
            ? 9900
            : cart.original_total_price -
                totalFeeIncludeSoildRoute -
                cart.total_discount,
          cart.original_total_price - eGiftTotal * 100,
        );
        const enableCartLevelSingle =
          document.querySelector("#CartDrawer").dataset
            .enable_cart_level_single == "true";
        /**
         * ## Campaign 3: Free Gift Box
         */
        if (
          activityType == this.activityType.FREE_BOX ||
          activityType == this.activityType.FREE_BOX_AND_UPDATE_PRICE ||
          enableCartLevelSingle
        ) {
          let cartTotalAmount = totalPriceWithoutGiftBox / 100;
          // 赠送Gift Box活动排除礼品卡
          let eGiftBoxTotal = 0;
          document
            .querySelector(".free-gift-progress")
            ?.setAttribute(
              "data-cart-total",
              cartTotalAmount - eGiftTotal - eGiftBoxTotal,
            );
        }
        if (openDrawer || this.isOpen()) {
          that.cartPart2(cart, openDrawer, returnFocusEl);
        }
        that.addScrollEvent();
        return;
      }
    },
    addScrollEvent() {
      //
      // $(".cart-container").on("scroll", () => {
      //   // deprecated
      //   //theme.resizeCart()
      // });
      $(document.body).data("vh", window.innerHeight);
      $(window).on("resize", () => {
        if (
          theme.isAndroid() &&
          document.querySelector("cart-drawer").isOpen()
        ) {
          // hide cart footer when opening cart drawer and pop up soft keyboard
          if (
            $(document.body).data("vh") - window.innerHeight > 100 &&
            $("#CartDrawer.drawer.drawer--right.drawer--is-open").length
          ) {
            $(".cart-area-footer").hide();
          } else {
            $(".cart-area-footer").show();
          }
        }
      });
      $('.cart-container input[name="updates"]').on("focus", (evt) => {
        if (theme.isAndroid()) {
          let el = evt.target.closest(".ajaxcart__product");
          let itemHeight = parseInt(
            window
              .getComputedStyle(el)
              .getPropertyValue("height")
              .replace("px", ""),
          );
          let index0 = 0;
          Array.from(el.parentElement.children).forEach((item, index) => {
            if (item == el) {
              index0 = index;
            }
          });
          evt.target.closest(".cart-container").scroll({
            top: itemHeight * (index0 - 1) - 20,
            behavior: "smooth",
          });
        }
      });
    },
    unloading() {
      this.status.loaded = true;
      this.loading(false);
    },
    cartPart2(cart, openDrawer, returnFocusEl) {
      this.unloading();
      const activityType = document.querySelector("#CartDrawer").dataset.type;
      const enableCartLevelSingle =
        document.querySelector("#CartDrawer").dataset
          .enable_cart_level_single == "true";
      document.dispatchEvent(
        new CustomEvent("updateCart" + config.namespace, {
          detail: cart,
        }),
      );

      if (Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }

      // If specifically asked, open the cart drawer (only happens after product added from form)
      if (openDrawer === true) {
        this.drawer.open(false, returnFocusEl);
        // const CART_ANIMATION_ELE_CLASS = `animation-label`, CART_ANIMATION_CLASS = '.increase-numbers'
        // $('.icon-cart').each((inde, item) => {
        //   $(item).closest('.cart-link').siblings(CART_ANIMATION_CLASS).addClass(CART_ANIMATION_ELE_CLASS)
        // })
        // setTimeout(() => {
        //   $(CART_ANIMATION_CLASS).each((index, ele) => $(ele).removeClass(CART_ANIMATION_ELE_CLASS))
        // }, 1000)
      }

      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: {
            cart: cart,
          },
        }),
      );
      /**
       * ## Campaign 3: Free Gift Box
       */
      if (
        activityType == this.activityType.FREE_BOX ||
        activityType == this.activityType.FREE_BOX_AND_UPDATE_PRICE ||
        enableCartLevelSingle
      ) {
        // TWO LEVEL GIFT BOX
        // if(theme.isPrimaryMarket?.())this.campaignFreeGiftBox?.(cart.items.map(item => item.discounts).flat(2), cart.items);
        this.loading(false);
      }
      // Free GIFT FOR ORDER VALUE
      // if (window.route_prefix == "/")
      //   this.campaignFreeGiftBoxAmount([], cart.items);
      /**
       * show discount amount by order level
       * TWO LEVEL AMOUNT DISCOUNT
       */
      // if (window.route_prefix == "/")this.campaignDiscountAmountOnOrdersValue( cart.items);

      /**
       * ## Campaign 7: Buy Garden Beds Free 2 Light and Update Price
       * ## Campaign 6: Buy Garden Beds Free 2 Light
       */
      if (
        (activityType ==
          this.activityType.BUY_GARDEN_BEDS_FREE_LIGHT_UPDATE_PRICE ||
          activityType == this.activityType.BUY_GARDEN_BEDS_FREE_LIGHT) &&
        !theme.isCA()
      ) {
        this.campaignBuyGardenBedsFreeLight?.(cart.items);
        this.loading(false);
      }
      //console.log(activityType==this.activityType.BUY_GARDEN_BEDS_FREE_LIGHT_UPDATE_PRICE)
      /***
       * ## Campaign 4: Manually Update Product Price
       * ## Campaign 7: Buy Garden Beds Free 2 Light and Update Price
       */

      //if (activityType == this.activityType.BOGO_AND_UPDATE_PRICE || activityType == this.activityType.FREE_BOX_AND_UPDATE_PRICE || activityType == this.activityType.UPDATE_PRICE || activityType == this.activityType.BUY_GARDEN_BEDS_FREE_LIGHT_UPDATE_PRICE) {
      window.campaignSavingInfoByUpdateProductPrice?.(cart);
      //}
      // console.log(activityType)
      /**
       * ## Campaign 7: Buy Garden Beds Free 2 Light and Update Price
       * ## Campaign 6: Buy Garden Beds Free 2 Light
       */
      // if (activityType == this.activityType.BUY_GARDEN_BEDS_FREE_LIGHT_UPDATE_PRICE || activityType == this.activityType.BUY_GARDEN_BEDS_FREE_LIGHT) {
      //window.promotionSaving?.()
      ///}
      /**
       * ## Campaign 5: 每满150, 赠送$30的礼品卡
       */
      if (activityType == this.activityType.FREE_30_FOR_150_ORDER_VALUE) {
        window.campaignFreeGiftCardInfo(cart);
      }
    },

    initQtySelectors: function (evt) {
      this.container.querySelectorAll(selectors.qtySelector).forEach((el) => {
        var selector = new theme.QtySelector(el, {
          namespace: ".cart-drawer",
        });
      });

      document.addEventListener(
        "cart:quantity.cart-drawer",
        this.updateItem.bind(this),
      );
    },
    /**
     * # -------------------------------- composter subscription action --------------------------------
     * ## sync update composter bundle in cart. for example: sync nums, sync deleting.
     * @param {*} key   cart line item key/v-id
     * @param {*} num   update number
     * @returns
     */
    syncBundle: function (key, num) {
      let update = {};
      let bundleItem = document.querySelector(
        `.ajaxcart-combo-box[data-key="${key}"][data-bundle],.ajaxcart-combo-box[data-v-id="${key}"][data-bundle]`,
      );
      if (bundleItem && bundleItem.getAttribute("data-bundle")) {
        let bundle = bundleItem.getAttribute("data-bundle");
        let idItem = document.querySelectorAll(
          `.ajaxcart-combo-box[data-bundle="${bundle}"]`,
        );
        let keyItem = document.querySelectorAll(
          `.ajaxcart-combo-box[data-bundle="${bundle}"]`,
        );
        let vIds = [];
        if (idItem?.length) {
          vIds = Array.from(
            new Set(
              Array.from(
                document.querySelectorAll(
                  `.ajaxcart-combo-box[data-bundle="${bundle}"]`,
                ),
              ).map((item) => {
                // Multiple same variant in cart splitely, utilize key to update number
                if (
                  document.querySelectorAll(
                    `[data-v-id="${item.getAttribute("data-v-id")}"]`,
                  ).length > 1
                ) {
                  return item.getAttribute("data-key");
                }
                return item.getAttribute("data-v-id");
              }),
            ),
          );
        } else if (keyItem?.length) {
          vIds = Array.from(
            new Set(
              Array.from(
                document.querySelectorAll(
                  `.ajaxcart-combo-box[data-bundle="${bundle}"]`,
                ),
              ).map((item) => item.getAttribute("data-key")),
            ),
          );
        }
        if (vIds.length > 0) {
          vIds.forEach((id) => {
            update[id] = num;
          });
          return update;
        } else {
          return null;
        }
      }
      {
        return null;
      }
    },
    staGreenHouseNum: function () {
      let greenhouse_num = Array.from(
        document.querySelectorAll(
          '.ajaxcart__product.ajaxcart-combo-box .vego-flex1 a[href*="vego-garden-pacific-greenhouse"]',
        ),
      ).reduce((res, item) => {
        res += parseInt(
          item
            .closest(".ajaxcart__product.ajaxcart-combo-box")
            .querySelector(".js-qty__num").value,
        );
        return res;
      }, 0);
      let greenhouse_fee_num = Array.from(
        document.querySelectorAll(
          '.ajaxcart__product.ajaxcart-combo-box .vego-flex1 a[href*="greenhouse-delivery-service"]',
        ),
      ).reduce((res, item) => {
        res += parseInt(
          item
            .closest(".ajaxcart__product.ajaxcart-combo-box")
            .querySelector(".js-qty__num").value,
        );
        return res;
      }, 0);
      return {
        greenhouse_num,
        greenhouse_fee_num,
      };
    },
    syncGreenhouseFeeBundle: function (key, num) {
      //let update = {}
      let bundleItem = document.querySelector(
        `.ajaxcart-combo-box[data-key="${key}"],.ajaxcart-combo-box[data-v-id="${key}"]`,
      );
      let nums_obj = this.staGreenHouseNum();
      if (
        bundleItem &&
        bundleItem.querySelector('a[href*="vego-garden-pacific-greenhouse"]') &&
        document.querySelector(
          '#CartContainer a[href*="greenhouse-delivery-service"]',
        )
      ) {
        let update_data = {};
        if (
          nums_obj.greenhouse_fee_num == nums_obj.greenhouse_num &&
          num == 0
        ) {
          update_data = {
            [key]: num,
            ["40771195043875"]: num,
          };
          return update_data;
        } else if (nums_obj.greenhouse_fee_num >= nums_obj.greenhouse_num) {
          let fee_num = num;
          if (num == 0) fee_num = nums_obj.greenhouse_num;
          update_data = {
            [key]: num,
            ["40771195043875"]: num,
          };
        } else {
          let fee_num_plus = window.cartPlusMinusQty ?? 0;
          update_data = {
            [key]: num,
            ["40771195043875"]:
              num == 0 ? 0 : nums_obj.greenhouse_fee_num + fee_num_plus,
          };
        }
        return update_data;
      } else if (
        bundleItem &&
        bundleItem.querySelector('a[href*="greenhouse-delivery-service"]') &&
        document.querySelector(
          '#CartContainer a[href*="vego-garden-pacific-greenhouse"]',
        )
      ) {
        let v_id = document
          .querySelector(
            '#CartContainer a[href*="vego-garden-pacific-greenhouse"]',
          )
          .getAttribute("href")
          .split("variant=")[1];
        let update_data = {};
        if (nums_obj.greenhouse_fee_num >= nums_obj.greenhouse_num) {
          update_data = {
            [key]: num,
            [v_id]: num,
          };
        } else {
          update_data = {
            [key]: num,
          };
        }
        return update_data;
      } else {
        return null;
      }
    },

    /**
     * 更新数量
     * @param {*} evt
     * @returns
     */
    updateItem: function (evt) {
      var key = evt.detail[0];
      var qty = evt.detail[1];
      if (!key || !qty) {
        return;
      }
      const CLEAR_NUM = -1;
      /**
       * skip zero of qty for clear cart item
       */
      if (qty === CLEAR_NUM) {
        qty = 0;
      }

      if (this.status.loading) {
        return;
      }
      this.loading(true);
      let bundleParam = this.syncBundle(key, qty);
      let greenhouse_fee_bundle = this.syncGreenhouseFeeBundle(key, qty);
      (bundleParam || greenhouse_fee_bundle
        ? theme.cart.updateItem({
            ...(bundleParam || {}),
            ...(greenhouse_fee_bundle || {}),
          })
        : theme.cart.changeItem(key, qty)
      )
        .then(
          function (cart) {
            if (cart.items) {
              $(".cart-errors").hide();
              this.updateSuccess(cart);
            } else {
              let msg_ = cart.description;
              if (msg_ == "no valid id or line parameter") {
                msg_ = "cart key changed; refresh cart and try again.";
              }
              $(".cart-errors").text(msg_).show();
              $("#CartContainer .js-qty__adjust.btn--loading").removeClass(
                "btn--loading",
              );

            }
            this.loading(false);
          }.bind(this),
        )
        .catch(
          function (XMLHttpRequest) {
            this.loading(false);
          }.bind(this),
        );
    },

    loading: function (state) {
      this.status.loading = state;

      if (state) {
        this.container.classList.add("is-loading");
      } else {
        this.container.classList.remove("is-loading");
      }
    },

    emptyCart: function () {
      // this.container.innerHTML = ''
      //clear cart areaa
      Object.keys(CartAreaConst).forEach((key) => {
        $(CartAreaConst[key]).html("");
      });
    },

    updateSuccess: function (cart) {
      this.buildCart(cart);
    },

    updateCartNotification: function (evt) {
      var cart = evt.detail;
      if (cart.items.length > 0) {
        document
          .querySelector(selectors.cartBubble)
          .classList.add("cart-link__bubble--visible");
      } else {
        document
          .querySelector(selectors.cartBubble)
          .classList.remove("cart-link__bubble--visible");
      }
    },
  });

  return CartDrawer
})()

theme.cartPage = (function () {
  var selectors = {
    checkoutBtn: '.cart__checkout',
    qtySelector: '.js-qty__wrapper',
  }

  var classes = {
    checkoutBtn: 'cart__checkout',
    cartNote: 'cart-notes',
    btnLoading: 'btn--loading',
    optionVariantPrefix: 'grid-product-variant-input', //variant class prefix
  }

  var config = {
    namespace: '.cartpage',
  }

  var container = document.getElementById('CartPageForm')

  function init() {
    // Add loading indicator on the checkout button (cart page and drawer)
    // Also check for required terms and conditions checkbox
    document.addEventListener('click', function (evt) {
      theme.allViewScaled()
      if (evt.target && evt.target.classList.contains(classes.checkoutBtn)) {
        evt.target.classList.add(classes.btnLoading)

        // Check if there is a required terms checkbox
        var termsCheckboxId = evt.target.dataset.terms
        if (termsCheckboxId) {
          var isChecked = document.getElementById(termsCheckboxId).checked

          if (isChecked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation)
            evt.target.classList.remove(classes.btnLoading)
            evt.preventDefault()
            return false
          }
        }
      } else if (
        /**
         * open popup
         */
        evt.target &&
        evt.target.classList.contains('grid-product-est__field')
      ) {
        if (theme.isMobile())
          return $(evt?.target)?.siblings?.('.grid-product-est__tip')?.data?.('vego.tooltip')?.show?.()
      } else if (
        /**
         * open popup
         */
        evt.target &&
        evt.target.classList.contains(theme.Popop.openHandlerClass.slice(1))
      ) {
        evt.stopPropagation()
        evt.preventDefault()
        try {
          // Mobile: 273906
          // Desktop: 273905

          // if (!theme.isMobile()) {
          //   window.__attentive.trigger(null, null, null, 389203)
          // } else {
          //   window.__attentive.trigger(null, null, null, 389265)
          // }
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.openForm(theme.isCA() ? 'YiLnXn' : 'RKiQVZ', () => console.log("showing signup form"));


        } catch (error) {
          console.log(error);
        }
        // $(theme.Popop.containerClass).show()
        // $(".modal--mobile-friendly-mask").show()
        // $(".preferential-information-maks").show()
      } else if (
        evt.target &&
        evt.target.classList.contains(theme.Popop.closeHandlerClass.slice(1))
      ) {
        evt.stopPropagation()
        evt.preventDefault()
        $(theme.Popop.containerClass).hide()

        $(".modal--mobile-friendly-mask").hide()
        $(".preferential-information-maks").hide()
        /**
         * target click is path
         */
      } else if ($(evt.target).closest('svg').length) {
        let elSvg = $(evt.target).closest('svg')[0]
        if (
          elSvg &&
          elSvg.classList.contains(theme.Popop.closeHandlerClass.slice(1))
        ) {
          evt.stopPropagation()
          evt.preventDefault()

          $(theme.Popop.containerClass).hide()
          $(".modal--mobile-friendly-mask").hide()
          $(".preferential-information-maks").hide()
        }
      }
    })

    document.addEventListener('change', function (evt) {
      if (evt.target && evt.target.classList.contains(classes.cartNote)) {
        var newNote = evt.target.value
        theme.cart.updateNote(newNote)
      }
      if (
        evt.target.classList.toString().indexOf(classes.optionVariantPrefix) >
        -1
      ) {
        theme.productForm.preOrder(evt.target)
      }
    })
    // live update on total price when the quantity changes
    if (document.getElementsByClassName('cart__product-qty')[0]) {
      let elements = document.getElementsByClassName('cart__product-qty')
      for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('input', function (event) {
          document.querySelector('.cart').submit()
        })
      }
    }

    if (document.getElementsByClassName('_add')[0]) {
      let elements = document.getElementsByClassName('_add')
      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', function (event) {
          event.target.previousElementSibling.value =
            parseInt(event.target.previousElementSibling.value) + 1
          let inputEvent = document.createEvent('HTMLEvents')
          inputEvent.initEvent('input', true, true)
          event.target.previousElementSibling.dispatchEvent(inputEvent)
        })
      }
    }

    if (document.getElementsByClassName('_sub')[0]) {
      let elements = document.getElementsByClassName('_sub')
      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', function (event) {
          event.target.nextElementSibling.value =
            parseInt(event.target.nextElementSibling.value) - 1
          let inputEvent = document.createEvent('HTMLEvents')
          inputEvent.initEvent('input', true, true)
          event.target.nextElementSibling.dispatchEvent(inputEvent)
        })
      }
    }

    if (container) {
      initCartForm()
    }
  }

  function initCartForm() {
    container.querySelectorAll(selectors.qtySelector).forEach((el) => {
      var selector = new theme.QtySelector(el, {
        namespace: config.namespace,
        onChange: (qty) => {
        }
      })
    })

    // Trigger click on hidden 'update' button when qty selector value changes
    document.addEventListener(
      'cart:quantity' + config.namespace,
      function (evt) {
        document.getElementById('CartPageUpdate').click()
      }
    )
  }

  return {
    init: init,
  }
})()

theme.cart = {
  /**
   * ajax add product to cart
   * @param {*} data
   * @returns
   */
  addCart: function (formData) {
    return new Promise((resolve, reject) => {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((response) => response.json())
        .then(
          function (data) {
            if (data.status === 422) {
              //this.error?.(data)
              reject(data)
            } else {
              resolve()
            }
          }.bind(this)
        )
    })
  },
  getCart: function () {
    var url = theme.routes.cart;
    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then((response) => response.json())
  },

  changeItem: function (key, qty) {
    return this._updateCart({
      url: theme.routes.cartChange,
      data: JSON.stringify({
        id: key,
        quantity: qty,
      }),
    });
  },
  /**
   * Check and Synchronous `pre-order` info in cart line items 
   * @param {*} cartsItems 
   * @returns 
   */
  updatePreOrder: async function (cartsItems) {
     if (!cartsItems) return;
     let url = "/products/9-in-1-modular-raised-garden-bed?view=cart-json";
     if(theme.isAu()){
      url = "/products/ez-microgreens-planter?view=cart-json";
     }
     let pre_order_data = await fetch(url);
     pre_order_data = await pre_order_data.text()
      var parser = new DOMParser();
      var doc = parser.parseFromString(pre_order_data, "text/html");
      var preDoc = doc.querySelector(".cart-drawer-container");
      if (preDoc) {
        window._preOrderDataV2 = preDoc
        .innerText.split(",,")
        .reduce((res, item) => {
          let items = item.split(':')
          if (items[0].trim()) res[items[0].trim()] = items[1];
          return res;
        }, {});
      }

        //console.log(window._preOrderDataV2);
    //console.log(doc.querySelector(".cart-drawer-container").innerText);
    //  const preOrderData = await theme.getPreOrderData();
    //  window._preOrderData = preOrderData;
    let items = []
    for (let i = 0; i < cartsItems.length; i++) {
      let item = cartsItems[i];
      // update pre order into new pre order 
      if (
        window._preOrderDataV2?.[item.variant_id] &&
        "Ships by: " + window._preOrderDataV2?.[item.variant_id] !==
          item.properties["_is_fullfillDate"]
      ) {
        items.push({
          line: i + 1,
          quantity: item.quantity,
          properties: {
            ...item.properties,
            _is_fullfillDate:
              "Ships by: " + window._preOrderDataV2[item.variant_id],
            _is_fullfillDate_ts:
              "" +
              new Date(window._preOrderDataV2[item.variant_id]).getTime() /
                1000,
          },
        });
      } else if (
        window._preOrderDataV2?.[item.variant_id] == "" &&
        item.properties["_is_fullfillDate"] != "In Stock"
      ) {
        // transfer pre order into in stock
        items.push({
          line: i + 1,
          quantity: item.quantity,
          properties: {
            ...item.properties,
            _is_fullfillDate: "In Stock",
            _is_fullfillDate_ts: "",
          },
        });
      }
    }
    if (!items.length) return
    let res = await Promise.all(items.map(async (item) => await this.changeProperties(item)))
    // trigger build cart action 
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: {
          addToCartBtn: null,
        },
      })
    )
  },
  changeProperties: async function (changeObj) {
    let res = await this._updateCart({
      url: theme.routes.cartChange,
      data: JSON.stringify(changeObj),
    });
    return res;
  },
  /**
   * ## update cart items
   * @param {*} keyV  {[cart.item.id]:quantity}
   * @returns
   */
  updateItem: function (keyV) {
    return this._updateCart({
      url: theme.routes.cartUpdate,
      data: JSON.stringify({
        updates: {
          ...keyV,
          //794864053: 2,
        },
      }),
    });
  },


  _updateCart: async function (params) {
    let response = await fetch(params.url, {
      method: 'POST',
      body: params.data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    response = response.json();
    return response;
    // .then((response) => response.json())
    // .then(function (cart) {
    //   return cart
    // })
  },

  updateNote: function (note) {
    return this._updateCart({
      url: '/cart/update.js',
      data: JSON.stringify({
        note: theme.cart.attributeToString(note),
      }),
    })
  },

  attributeToString: function (attribute) {
    if (typeof attribute !== 'string') {
      attribute += ''
      if (attribute === 'undefined') {
        attribute = ''
      }
    }
    return attribute.trim()
  },
}


class CartDrawerEl extends BaseV2 {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initData = {
      selector: this.dataset.selector,
    };
    this.init();
  }
  initData = {
    selector: '',
  };
  setActiveByVariant() {

  }
  open() {
    window.cartDrawerInstance.drawer.open({ currentTarget: document.querySelector('.js-drawer-open-cart ') })
  }
  initDiscountApp() {
    window.discountOnCartProAppLoaded = false
    let discount_on_cart_pro = `https://d9fvwtvqz2fm1.cloudfront.net/shop/js/discount-on-cart-pro.min.js?shop=vego-gardening-store.myshopify.com`
    document.querySelector(`[src="${discount_on_cart_pro}"]`)?.remove?.()
    window.appendScript(`${discount_on_cart_pro}`, () => { })
  }
  isOpen() {
    return this.classList.contains('drawer--is-open')
  }
  init() {
    window.cartDrawerInstance = new theme.CartDrawer()
    setTimeout(() => {
      //this.initDiscountApp()
    }, 1000)
    //initDiscountEvent()
  }
}

if (!customElements.get(`cart-drawer`)) {
  customElements.define(`cart-drawer`, CartDrawerEl);
}



let bundleInfo = []

const vgBeds = [
  "11-tall-4-in-1-modular-metal-raised-garden-bed-kit",
  "11-tall-6-in-1-modular-metal-raised-garden-bed-kit",
  "11-tall-9-in-1-modular-metal-raised-garden-bed-kit",
  "11-tall-10-in-1-modular-metal-raised-garden-bed-kit",
  "11-tall-42-wide-round-metal-raised-garden-bed-kit",
  "17-tall-4-in-1-modular-metal-raised-garden-bed-kit",
  "vego-garden-6-in-1-modular-raised-garden-bed-kit",
  "9-in-1-modular-raised-garden-bed",
  "10-in-1-modular-metal-raised-garden-bed-kit",
  "17-tall-42-wide-round-metal-raised-garden-bed",
  "32-extra-tall-4-in-1-modular-raised-garden-bed-kit",
  "32-extra-tall-6-in-1-modular-raised-garden-bed-kit",
  "32-extra-tall-9-in-1-modular-raised-garden-bed-kit",
  "32-extra-tall-10-in-1-modular-raised-garden-bed-kit",
  "32extra-tall-42-round-metal-garden-bed",
  "17-tall-l-shaped-raised-garden-bed-kit-standard-size",
  "17-tall-l-shaped-raised-garden-bed-kit-large-size",
  "17-tall-u-shaped-raised-garden-bed-kit-standard-size",
  "17-tall-u-shaped-raised-garden-bed-kit-large-size",
  "17-tall-u-shaped-raised-garden-bed-kit-jumbo-size",
  "cascading-raised-garden-bed-kit-standard-size",
  "17-inch-tall-kids-first-raised-bed",
  "17-tall-berry-garden-bed-30-wide-twin-pack",
  "herb-garden-24-wide-17-tall-twin-pack",
  "self-watering-garden-bed",
  "self-watering-planter",
  "rolling-self-watering-garden-bed",
  "elevated-rolling-garden-bed",
  "dragon-fruit-rolling-planter",
  "rolling-planter-twin-pack",
  "selling-plans-ski-wax",
];

if (theme.isCA()) {
  const tempBundleInfo = [];
  for (const info of bundleInfo) {
    let skip = false;
    for (const bundle of info.bundles) {
      for (const product of bundle.products) {
        if (!vgBeds.includes(product.handle)) {
          skip = true;
          break;
        }
      }
      if (skip) {
        break;
      }
    }
    if (!skip) {
      tempBundleInfo.push(info);
    }
  }
  bundleInfo = tempBundleInfo;
}

/**
* get element height by selector
* @param {*} selector 
* @returns 
*/
theme.getH = function (selector) {
  let el = document.querySelector(selector);
  if (!el) return 0;
  let h = getComputedStyle(document.querySelector(selector)).getPropertyValue('height')
  if (h == 'auto') return 0;
  return parseFloat(h.replace('px', ''))
}
/**
* update cart main content height dynamically 
*/
theme.setCartHeightOfMainContent = function () {
  if (theme.isMobile()) return;
  let bannerH = theme.getH('.vego-prompt-banner'); // cart banner height
  setTimeout(() => {
    let cartHeaderH = theme.getH('.drawer__fixed-header'); // cart header height
    document.querySelector('#CartContainer').style.height = `calc(100vh - ${bannerH}px - ${cartHeaderH}px)`
    document.querySelector('#CartContainer .drawer__scrollable').style.height = `calc(100vh - ${bannerH}px - ${cartHeaderH}px)`
  }, 0)
}
theme.disableViewScaled=()=>{
  try {
    document
      .querySelector('[name="viewport"]')
      .setAttribute(
        "content",
        "width=device-width, initial-scale=1, height=device-height, minimum-scale=1, maximum-scale=1",
      );
  } catch (error) {console.log(error);}

}
theme.allViewScaled=()=>{
   try {
     document
       .querySelector('[name="viewport"]')
       .setAttribute(
         "content",
         "width=device-width, initial-scale=1, height=device-height, minimum-scale=1, maximum-scale=5",
       );
   } catch (error) {
     console.log(error);
   }

}
theme.resizeCart = function () {
  if (!document.querySelector('#CartDrawer')) return;
  const cartContainerSelector = '.cart-container'
  const clientHeight = window.innerHeight
  let cart_drawer = document.querySelector('#CartDrawer')
  if (cart_drawer) cart_drawer.style.height = `${clientHeight}px`

  // top title height
  let topTitleHeight = window.getComputedStyle(document.querySelector('#CartDrawer .drawer__fixed-header')).getPropertyValue('height')
  if (topTitleHeight == 'auto') {
    topTitleHeight = '49px'
  } else {
    topTitleHeight = topTitleHeight
  }
  let topTitleHeightNum = parseInt(`${topTitleHeight}`.replace('px', ''))
  $(cartContainerSelector).height(`${window.innerHeight - topTitleHeightNum}px`)
  theme.setCartHeightOfMainContent()
}


theme.cartPage.init()
